/* eslint max-len: 0 */
import i18next from 'i18next';
import React from 'react';

i18next.init({
  lng: 'en',
  resources: {
    en: {
      translation: {
        brand_name: 'Katalon TestOps',
        Dashboard: 'Dashboard',
        Help: 'Help',
        404: 'Page Not Found',
        Login: 'User Login',

        'login#login_title': 'Sign In',
        'login#signup_title': 'Sign Up',
        'login#placeholder_password': 'Password',
        'login#remember_me': 'Remember me',
        'login#login_button': 'Sign in',
        'login#forgot_password': 'Forgot your password?',
        'login#is_new_member': 'New Member?',
        'login#sign_up_now': 'Sign Up Now',
        'login#welcome': 'Sign in with your Katalon account',
        'login#forgot_password_success': 'Please check your email for a link to reset your password. ' +
          'If it doesn’t appear within a few minutes, check your spam folder.',
        //         'login#sso': 'Sign in using SSO',
        'login#select_idp': 'Select Identity Provider',
        'login#try_again_or_contact_support': 'Attempt to log in again or contact support@katalon.com.',

        reset_password: 'Update password',
        'reset_password#confirm_password': 'Confirm password',
        'reset_password#reset_password_button': 'Update password',
        'reset_password#token_expired': 'This link has expired.',
        'reset_password#token_accepted': 'This link has been used to reset password.',
        'reset_password#success': 'Your password has been reset.',

        'no_execution_history#tab_name': 'Feed me some data!',
        method: 'Method',
        status_text: 'Status Text',
        'status-placeholder-select': 'Select a status',
        'execution_request#size': 'Size',
        'execution_request#action': '',
        'execution_request#general': 'General',
        'execution_request#request_header': 'Request Headers',
        'execution_request#response_header': 'Response Headers',
        'execution_request#request_params': 'Request Parameters',
        'execution_request#request_payload': 'Request Payload',
        'execution_request#response_content': 'Response',
        'execution_request#timings': 'Timings',
        'api_key#key': 'Key',
        'api_key#action': '',
        'api_key#created_at': 'Created At',
        'api_key#choose': 'Choose an API Key',
        'api_key#last_used': 'Last Used',
        'api_key#expiration_date': 'Expiration Date',
        'api_key#status': 'Status',
        'api_key#create_new_key': 'Create API Key',
        'api_key#create': 'Create',
        'api_key#delete_api': 'Are you sure you want to delete this key?',
        'api_key#delete_notice': 'Any applications or scripts using this key will no longer be able to access. You cannot undo this action.',
        'api_key#active': 'Active',
        'api_key#key_name': 'Key Name',
        'api_key#expiration': 'Expiration',
        'api_key#expiry_explain': 'The key will never expire!',
        'api_key#expiry_on': 'The key will expire on ',
        'api_key#expired': 'Expired',
        'api_key#date_picker_placeholder': 'Expiration',
        'api_key#table_title': 'API Keys',
        'api_key#intro': 'Treat your API Keys like passwords and keep them secret. When working with the API, use API Keys as environment variables instead of hardcoding them into your programs.',
        'job#queued_at': 'Queued at',
        'job#start_time': 'Started',
        'job#duration': 'Duration',
        'job#stop_time': 'End time',
        'job#action': '',
        'job#rerun': 'Rerun',
        'job#build_number': 'Build Number',
        'job#execution': 'Results',
        'job#trigger_by': 'By',
        jobs: 'Sessions',
        'job#title': 'Session: #{{name}}',
        'jobs#queued-jobs': 'Queued Sessions',
        'jobs#queued-job-count': 'Queued Session Count',
        'jobs#running-job-count': 'Running Session Count',
        'jobs#not-running-job': 'Not Running Session',
        'jobs#summary': 'Session Summary',
        'test-project#command': 'Command',
        'test-project#command-hint': 'e.g. -browserType="Chrome" -retry=0 -statusDelay=15 -testSuitePath="Test Suites/TS_RegressionTest"',
        'test-project#description': 'Description',
        'test-project#download': 'Download',
        'test-project#update': 'Save',
        'test-project#create': 'Create',
        'test-project#upload': 'Upload',
        'test-project#action': '',
        'test-project#execute': 'Execute Script Repository',
        'test-project#upload-hint': 'e.g. ',
        'test-projects': 'Script Repositories',
        'import-script-repo': 'Import Script Repository',
        'test-project': 'Script Repository',
        'test-projects#upload-title': 'Upload Script Repository',
        'test-project#edit': 'Edit Script Repository',
        'test-project#git#vcs-type': 'Source Type',
        'test-project#git#branch': 'Branch',
        'test-project#git#connect': 'Connect',
        'test-project#git#password': 'Password',
        'test-project#git#accessKeyId': 'Access Key ID',
        'test-project#git#secretAccessKey': 'Secret Access Key',
        'test-project#git#personal-access-token': 'Personal Access Token',
        'test-project#git#app-password': 'App Password',
        'test-project#git#api-token': 'API Token',
        'test-project#git#repourl': 'Repository URL',
        'test-project#git#target-directory': 'Target Directory',
        'test-project#git#tooltip-target-directory': 'If your Katalon Studio project is in a sub-directory in your Git repo, please provide the directory path to that folder containing all the project files',
        'test-project#default-repository': 'Set as default repository',
        'test-project#text-confirmation-test-project': 'Are you sure you want to set this script repository as default? This will turn off the current default one.',
        'test-project#button-confirmation-test-project': 'Confirm',
        'test-project#title-confirmation-test-project-dialog': 'Confirmation',
        'test-project#tooltip-default-repository': 'If you enable the setting, this Script Repository will be displayed by default whenever you schedule a test run.',
        'test-project#file-non-zip': 'Please upload a script repository in .zip format.',
        'test-project#exceed-limit-size': '<b>{{fileName}}</b> file size exceeds the maximum limit. The maximum allowed file size is 1000 MB.',
        'test-project#allow-merge': 'Link existing test execution results with test cases having the exact same paths and names.',
        'test-project#not-select-another-script-repo': 'Remove added test cases to switch to another script repository',
        'test-project#invalid': 'Invalid Test Project',
        'test-project#need-whitelist-ip-addresses-info-banner-1': 'Katalon will consistently utilize your connection from specific IP addresses listed in our ',
        'test-project#document-info-banner': 'documentation',
        'test-project#need-whitelist-ip-addresses-info-banner-2': '. Please ensure you permit inbound traffic from these IPs in your firewall.',

        'run-configuration#update': 'Edit Test Run',
        'run-configuration#command': 'Command',
        'run-configuration#create-btn': 'Create',
        'run-configuration#update-btn': 'Save',
        'run-configuration#add-btn': 'Add',
        'run-configuration#summary': 'Summary',
        'run-configuration#remove-agent-btn': 'Remove agent',
        'run-configuration#dup-agent-noti': 'This agent has been already added.',
        'run-configuration#dup-environment-noti': 'This environment has been already added.',
        'run-configuration#create-noti': 'Schedule has been created successfully.',
        'run-configuration#update-noti': 'Schedule has been updated successfully.',
        'run-project#command-hint': 'e.g. -browserType="Chrome" -retry=0 -statusDelay=15 -testSuitePath="Test Suites/TS_RegressionTest"',
        'run-configuration#type': 'Type',
        'run-configuration#test-suite-collection': 'Test Suite Collection',
        'run-configuration#katalon-command': 'Katalon Command',
        'run-configuration#generic-command': 'Generic Command',
        'run-configuration#execution-enviroment': 'Execution Environment',
        'run-configuration#test-time-out': 'Test Timeout',
        'run-configuration#time-out': 'Timeout in minutes',
        'run-configuration#kobiton-devide-id': 'Kobiton Device ID',
        'run-configuration#katalon-runtime-engine': 'Katalon Runtime Engine',
        'run-configuration#execution-mode': 'Execution Mode',
        'run-configuration#ks-version#note': 'Note: Only compatible with Katalon Studio version 8.0 or later.',
        'run-configuration#enable-kobiton-integration': 'Enable Kobiton Integration',
        'run-configuration#not-supported-mobile': 'Mobile and Window App environments are not supported',
        'run-configuration#baseline-collection-tooltip': 'Select a Baseline Collection ID or generate a new Baseline Collection to compare with the captured image(s).',
        'run-configuration#baseline-collection-default': 'Generate a new Baseline Collection',
        'run-configuration#xray-import-report-type': 'Xray Push Mechanism',
        'run-configuration#xray-test-plan': 'Xray Test Plan',
        'run-configuration#test-suite-web-services-guide': 'This tab is dedicated to running API tests. For mixed UI and API tests, please switch to the other available tabs.',
        'test-suite-collection-override#selected-rows-count': '{{countRowsSelected}} of {{total}} items are selected',
        'test-suite-collection-override#configure-testcloud-environment': 'Configure TestCloud environments for Test Suites',
        'test-suite-collection-override#configure-selected-test-suite': 'Configure TestCloud environments for selected Test Suites',
        'test-suite-collection-override#configure-environment': 'Configure environments for Test Suites',
        'test-suite-collection-override#last-configuration': 'Last configuration',
        'test-suite-collection-override#header-colunm-name-test-suite': 'Name',
        'test-suite-collection-override#header-colunm-name-testcloud-environment': 'Environments',
        'test-suite-collection-override#save': 'Save',
        'test-suite-collection-override#no-data-to-display': 'There are no data to display',
        'test-suite-collection-override#assign-test-environment-test-suite': 'Assign Test Environment for Test Suite',
        'plan#step1': 'Select Script Repository',
        'plan#step1#desc': 'Select an existing Script Repository or create a new one ',
        'plan#step1#no#onboarding': 'Learn how to create a script repository ',
        'plan#step1#warning#create-script-repository': 'Please create a script repository first',
        'plan#step1#warning#select-testcloud-environment': 'Please select TestCloud Environment',
        'testcloud-environment#test-suite': 'Configure Test Environment for Test Suite',
        'testcloud-environment#generic-command': 'Configure Test Environment for Generic Command',
        'testcloud-environment#katalon-command': 'Configure Test Environment for Katalon Command',
        'testcloud-environment#test-suite-collection': 'Configure Test Environment for Test Suite Collection',
        'testcloud-environment#title': 'TestCloud',

        'agent#details': 'Agent Details',
        'agent#name': 'Name',
        'agent#version': 'Version',
        'agent#uuid': 'UUID',
        'agent#ip': 'IP',
        'agent#last-ping': 'Last Ping',
        'agent#hostname': 'Hostname',
        'agent#threshold': 'Threshold',
        'agent#num-executing-jobs': 'Total Executing Sessions',
        'agent#num-assigned-jobs': 'Total Assigned Sessions',
        'agent#update': 'Update',
        'agent#threshold-warning': 'The maximum number of sessions that an agent can execute concurrently.',
        'agent#assigned-jobs': 'Assigned Sessions',
        'agent#executing-jobs': 'Executing Sessions',
        'latest-job': 'Latest Sessions',
        'running-job': 'Running Sessions',
        'native-app#description-uploader-1': 'Supported files are .apk, .aab, .ipa',
        'native-app#description-uploader-2': 'Apps will be stored for 60 days and shared with your team.',
        'native-app#button-uploader': 'Upload Application',
        'native-app-error-message-uploader#app-size-validation': 'File too large to upload',
        'native-app-error-message-uploader#app-type-validation': 'File must be .apk, .aab, .ipa',
        'native-app-success-message-uploader#upload-success': 'Upload the application successfully',
        'app#remove-app': 'Delete Application',
        'app#application-name-column': 'Application Name',
        'app#file-name-column': 'File Name',
        'app#version-name-column': 'Version',
        'app#version-name-column-tooltip': 'The value of "CFBundleShortVersionString" in iOS or "versionName" in Android.',
        'app#operating-system-column': 'Operating System',
        'app#status-column': 'Status',
        'app#identify-column': 'Identifier',
        'app#uploaded-date-column': 'Uploaded date',
        'app#app-id': 'App ID',
        'app#version-code-column': 'Build',
        'app#version-code-column-tooltip': 'The value of "CFBundleVersion" in iOS or "versionCode" in Android.',
        'app#app-size': 'Size',
        'app#version-ios': 'The value of "CFBundleShortVersionString" in Info.plist.',
        'app#version-android': 'The value of "versionName" in the app manifest.',
        'app#build-ios': 'The value of "CFBundleVersion" in Info.plist.',
        'app#build-android': 'The value of "versionCode" in the app manifest.',
        settings: 'Settings',
        notifications: 'Notifications',
        'notifications#mask-as-read': 'Mark as read',
        'notifications#mask-as-unread': 'Mark as unread',
        'notifications#mask-all-as-read': 'Mark all as read',
        'notifications#empty': 'You have no notifications at this time.',
        'user-settings#grid-detail': 'Notify me when:',
        'user-settings#job-start': 'Any scheduled session starts',
        'user-settings#job-end': 'Any scheduled session ends',
        'user-settings#execution': 'Test Management',
        'user-settings#execution-detail': 'Receive email notifications of successfully uploaded test results.',
        'user-settings#execution-failed': 'Notify me only when a failed test run has been uploaded to Katalon TestOps',
        'user-settings#testcase-failed': 'Notify me only when a failed test run, which is assigned to me, has been uploaded to Katalon TestOps',
        'user-settings#execution-never': 'Do not send me any notification emails',
        'user-settings#execution-all': 'Notify me when any new test run has been uploaded to Katalon TestOps',
        'user-settings#weeklyupdate': 'Weekly Updates',
        'user-settings#weeklyupdate-detail': 'Receive weekly reports based on your testing activities',
        'user-settings#external-recipients': 'External Recipients',
        'user-settings#forward-to-external-recipients': 'Forward notification to external recipients',
        'user-settings#external-recipients-placeholder': 'Enter comma-separated email addresses',
        'user-settings#external-recipients-note': 'Note: Recipients will receive notifications based on your selected preferences',
        'user-settings#unsubscribe-daily-report-dialog#content': "Are you sure you'd like to stop receiving daily summary emails from project ",
        'user-settings#unsubscribe-daily-report-dialog#success-toast': 'The Daily Summary Report for <b>{{projectName}}</b> has been unsubscribed successfully.',

        'project-settings-bdd-label': 'Enable BDD reports',
        'project-settings-bdd-description': 'Enable this setting to view BDD reports in TestOps Center. ',
        'project-name-settings': "{{projectName}}'s Settings",
        'project-settings#remove-user-success-message': 'User <b>{{userName}}</b> was removed.',

        'email-configuration#title': 'Mail Server Setting',
        'email-configuration#host': 'Host',
        'email-configuration#port': 'Port',
        'email-configuration#password': 'Password',
        'email-configuration#protocol': 'Protocol',
        'email-configuration#test-recipient': 'Test Recipient',
        'email-configuration#update': 'Update',
        'email-configuration#send-test-email': 'Send test mail',

        configuration: 'Settings',
        config: 'Configuration',

        'table#empty-message': 'There is no data to display.',
        'table#loading-message': 'Loading...',
        'table-header#project': 'Project',
        'table-header#testsuite': 'Name',
        'table-header#profile': 'Profile',
        'table-header#platform': 'Platform',
        'table-header#startTime': 'Started',
        'table-header#duration': 'Duration',
        'table-header#average-duration': 'Average Duration',
        'table-header#total': 'Total',
        'table-header#totalPassed': 'P',
        'table-header#totalFailed': 'F',
        'table-header#totalError': 'E',
        'table-header#totalIncomplete': 'I',
        'table-header#totalSkipped': 'S',
        'table-header#totalUnresolved': 'U',
        'table-header#totalAssertion': 'Assertions',
        'table-header#action': '',
        'table-header#testSuite': 'Test Suite',
        'table-header#errorMessage': 'Error Message',
        'table-header#flakiness': 'Flakiness (%)',
        'table-header#history-old-new': 'History (Old → New)',
        'table-header#incidents': 'Tasks',
        'table-header#comments': '',
        'table-header#browser': 'Browser',
        'table-header#osVersion': 'OS',
        'table-header#jira-issues': 'Jira Requirements',
        'table-header#machine-key': 'Machine ID',
        'table-header#license-type': 'License Type',
        'table-header#product': 'Product',
        'table-header#paid-amount': 'Paid Amount (USD)',
        'table-header#numberUser': 'Number of Users',
        'table-header#totalTestObject': 'Number Test Object',
        time: 'Time',
        'table-header#requirements': 'Requirements',
        'table-header#averageDuration': 'Average Duration',
        'table-header#maxDuration': 'Max Duration',
        'table-header#minDuration': 'Min Duration',
        'table-header#platform-profile': 'Platform - Profile',
        'table-header#number-of-executions': 'No. of executions',
        'table-header#status': 'Status',
        'table-header#assignee': 'Assignee',
        'table-header#title': 'Title',
        'table-header#priority': 'Priority',
        'table-header#severity': 'Severity',

        incidents: 'Tasks',
        'incident#create-task': 'Create Task',
        'incident#description': 'Description',
        'incident#description-preview': 'Description Preview',
        'incident#create': 'Create',
        'incident#no-team': 'No team',
        'incident#createdAt': 'Created At',
        'incident#updatedAt': 'Updated At',
        'incident#removal-warning': 'Task is being removed on October 1st, 2019. ' +
          'This is to enhance the integration of Katalon TestOps with other task management tools and focus on core features of TestOps which are test execution and reporting. ' +
          'Please take the necessary action to back up your data!',

        integrations: 'Integrations',
        'integrations#katalon-studio': 'Katalon Studio',
        'integrations#jira': 'Jira',
        'integrations#jira-xray': 'Jira/Xray',
        'integrations#kobiton': 'Kobiton',
        'integrations#slack': 'Slack',
        'integrations#junit-4': 'JUnit 4',
        'integrations#junit-5': 'JUnit 5',
        'integrations#test-ng': 'Test NG',
        'integrations#mocha': 'Mocha',
        'integrations#cypress': 'Cypress',
        'integrations#jest': 'Jest',
        'integrations#jasmine': 'Jasmine',
        'integrations#pytest': 'Pytest',
        'integrations#protractor-jasmine': 'Protractor Jasmine',
        'integrations#protractor-mocha': 'Protractor Mocha',
        'integrations#cli': 'CLI',
        'integrations#report-uploader': 'Report Uploader',
        'integrations#docker': 'Docker',
        'integrations#github-action': 'Github Action',
        'integrations#circle-ci': 'Circle CI',
        'integrations#gitlab-ci': 'Gitlab CI',
        'integrations#aws-codebuild': 'AWS Codebuild',
        'integrations#azure-devops-pipelines': 'Azure DevOps Pipelines',
        'integrations#robot': 'Robot Framework - Python',
        'integrations#jenkins': 'Jenkins',
        'integrations#katalon-cli': 'Katalon CLI',
        'reportUploader#copy-and-paste': 'Copy & paste the following command to upload report',
        'reportUploader#copy-snippet': 'Copy the following snippet and paste it into your .yml file.',

        import: 'Import',
        'frameworks-integration': 'Framework Integration',
        'import-katalon-report': 'Katalon Studio Integration',
        'report-uploader': 'CI Integration',
        'badge#active': 'Active',
        'badge#closed': 'Closed',
        'frameworks-integration#generate-api-key': 'If there is no existing API key, create a new one ',
        'frameworks-integration#generate-api-key-des': 'Select an existing API key from the drop-down list below as your credentials to integrate Katalon TestOps with ',
        'frameworks-integration#configure-credentials': 'TestOps credentials & project',
        'frameworks-integration#configure-proxy': 'Proxy (optional)',
        'frameworks-integration#configure-proxy-description': 'Input values to each field in the following command to configure the proxy.',
        'frameworks-integration#uploadreport': 'Run tests and upload reports',
        'frameworks-integration#view-report-header': 'View reports',
        'frameworks-integration#view-report-content': 'Navigate to {{-route}} to view test results.',
        'frameworks-integration#createfile': 'Create a new file named {{-fileName}} with the below content.',
        'dependency-js#description': 'Use the following command to install the Katalon TestOps plugin for {{name}}.',

        license_keys: 'Licenses',
        kse_timeout_setting: 'Idle Timeout',
        account_settings: 'Account Settings',
        kse_timeout_enabled: 'Idle timeout enabled for this organization',
        kse_timeout_disabled: 'Idle timeout disabled for this organization',
        'kse_timeout#title': 'Idle Timeout (Katalon Studio Enterprise)',
        'kse_timeout#enable_timeout': 'Enable Timeout',
        'kse_timeout#time-out': 'Timeout in minutes',
        'kse_timeout#time-out-bypass': 'Idle timeout bypass limit',
        'kse_timeout#time-out-bypass#description': 'Input the number of times users are allowed to continue after the timeout. Leaving this field blank when there’s no constraints on the timeout dialog closure.',
        'kse_timeout#update': 'Update',
        kse_license_keys: 'Katalon Studio Enterprise (Node-locked)',
        'kse_license_keys#abbr': 'KSE Node-locked',
        unlimited_kse_license_keys: 'Katalon Studio Enterprise (Floating)',
        'unlimited_kse_license_keys#abbr': 'KSE Floating',
        kse_timeout_changed: 'The changes have been saved.',
        engine_license_keys: 'Katalon Runtime Engine (Node-locked)',
        'engine_license_keys#abbr': 'KRE Node-locked',
        unlimited_engine_license_keys: 'Katalon Runtime Engine (Floating)',
        'unlimited_engine_license_keys#abbr': 'KRE Floating',
        floating_engine_license_keys: 'Katalon Runtime Engine DevOps',
        'floating_engine_license_keys#abbr': 'KRE DevOps',
        testops_license_keys: 'Katalon TestOps OnPremise',
        'testops_license_keys#abbr': 'KTOP',
        'license_keys#create_license_key': 'Create Offline License',
        'license_keys#create_kse_license_key': 'Create KSE Node-locked License',
        'license_keys#create_unlimited_kse_license_key': 'Create KSE Floating License',
        'license_keys#create_engine_license_key': 'Create KRE Node-locked License',
        'license_keys#create_unlimited_engine_license_key': 'Create KRE Floating License',
        'license_keys#create_testops_license_key': 'Create Katalon TestOps OnPremise License',
        'license_keys#license_key_copied': 'License has been copied to your clipboard.',
        'license_keys#machine_id': 'Machine ID',
        'license_keys#machine_id_placeholder': 'Your Machine ID',
        'license_keys#create': 'Create',
        'license_keys#license_key': 'License',
        'license_keys#license_keys': 'Licenses',
        'license_keys#created_at': 'From',
        'license_keys#expiration_date': 'Renewed At',
        'license_keys#valid_until': 'Valid Until',
        'license_keys#number': 'Session Quota',
        'license_keys#feature': 'Feature',
        'license_keys#user': 'By',
        'license_keys#quota': 'Subscribed Licenses',
        'license_keys#expiry_date': 'Expiry Date',
        'license_keys#type': 'Type',
        'license_keys#remaining': 'Available Licenses',
        'license_keys#machine_quota': 'Machine Quota',
        'license_keys#unlimited': 'Unlimited',
        'license_keys#purchase': 'Subscribe more!',
        'license_keys#quota_header': 'Subscription',
        'license_keys#online': 'Online Licenses',
        'license_keys#online@licensed_users': 'Licensed Users',
        'license_keys#online@invited': 'Invited {{email}}',
        'license_keys#online@invalid_email': 'Invalid email',
        'license_keys#online@choose_from_list': 'Please choose one user from the list',
        'license_keys#online@remove_tooltip': 'Remove feature',
        'license_keys#online@confirm_removal': 'Do you want to remove user: {{email}} from {{product}}?',
        'license_keys#online@user_removed': 'User {{email}} was removed',
        'license_keys#online@engine_notice': 'Organization users can use KRE Node-locked license by default once the KRE Node-locked license is purchased.',
        'license_keys#online@unlimited_engine_notice': 'Organization users can use KRE Floating license by default when there\'s only KRE Floating subscription',
        'license_keys#online@default_notice': 'You need to invite users to your Organization to make their accounts appear in the drop-down list.',
        'license_keys#online-info': 'Online licenses will be released at the end of each Katalon Studio session.',
        'license_keys#offline': 'Offline Licenses',
        'license_keys#offline-info': 'Offline licenses will expire in two months, or at the end of the subscription term if it happens earlier.',
        'license_keys#create_testting_license': 'Create Testing License',
        'license_keys#create_testting_license_title': 'Not sure if this machine ID is correct, create an offline license for testing purpose only',
        manage_license: 'Manage my licenses',
        goto_testops: 'Go to TestOps',
        'go-to-configuration': 'Go to configuration',
        'license_keys#num_of_user': 'Number Of Users',
        'license_keys#KSEquota': 'KSE Quota',
        'license_keys#REquota': 'RE Quota',
        'license_keys#input_machine_id': 'Machine ID can be found in Katalon Studio activation log',

        'license_keys#kse_license': 'KSE Node-Locked License',
        'license_keys#unlimited_kse_license': 'KSE Floating License',
        'license_keys#kre_license': 'KRE Node-Locked License',
        'license_keys#unlimited_kre_license': 'KRE Floating License',
        'license_keys#testops_license': 'TestOps License',
        'license_keys#description': 'Description',

        organization_session: 'License Utilization',
        KSE: 'KSE',
        ENGINE: 'KRE',
        FLOATING_ENGINE: 'KRE-DevOps', // when replace - with space please update StatusBarChart to avoid exception '#.progress-duration-FLOATING_ENGINE-KRE DevOps' is not a valid selector

        machine: 'Registered Machines',
        plugins: 'Plugins',

        action: '',
        add: 'Add',
        clear: 'Clear',
        add_user_condition: 'Only users in the organization can be added to the team',
        add_user_to_project_condition: 'Only users in the organization can be added to the project',
        add_user_header: 'Add User to Team',
        add_user_to_project: 'Add User to Project',
        add_user_to_project_placeholder: 'Select users to add to your project.',
        add_user_to_team_placeholder: 'Select users to add to your team.',
        ascending: 'Ascending',
        agent: 'Test Environments',
        'agent-setup#block-page': 'Page moved',
        'agent-setup#block-page#go-to-new-location': 'Go To New Location',
        local_agent: 'Local Test Environments',
        k8s_agent: 'Kubernetes Environments',
        operatingSystem: 'Operating System',
        browser: 'Browser',
        agent_configuration: 'Agent Configuration',
        analysis: 'Analysis',
        api_performance: 'API Performance',
        bug_reports: 'Bug Reports',
        cancel: 'Cancel',
        close: 'Close',
        no: 'No',
        chat: 'Chat',
        community: 'Community',
        comments: 'Comments',
        results: 'Results',
        create_team: 'Create Team',
        create_project: 'Create Project',
        delete: 'Delete',
        descending: 'Descending',
        description: 'Description',
        documentation: 'Documentation',
        dashboard: 'Dashboard',
        download: 'Download',
        edit: 'Edit',
        duplicate: 'Duplicate',
        email: 'Email',
        emails: 'Emails',
        environments: 'Environments',
        'plan#remove@success': 'Schedule {{id}} and all of its corresponding jobs will be deleted.',
        'plan#remove@wrong_id': 'Schedule ID mismatched.',
        executions: 'Test Runs',
        executions_overview: 'Overview',
        executions_overview_title: 'Overview Test Runs',
        'previous-test-run': 'Previous Test Runs',
        'execution#title': 'Test Run: #{{order}} {{-name}}',
        execution_comparison: 'Test Runs Comparison',
        running_executions: 'Running Test Runs',
        feature_requests: 'Feature Requests',
        files: 'Files',
        grid: 'Test Run Types',
        history: 'History',
        id: 'ID',
        import_junit_reports: 'Import JUnit Reports',
        incoming_webhook_url: 'Incoming Webhook URL',
        incoming_webhook: 'Incoming Webhook',
        issues: 'Tasks',
        issue_id: 'Task ID',
        katalon_recorder_backup: 'Katalon Recorder Backup',
        katalon_recorder_backup_intro: 'The backups will be retained for 7 days.',
        last_execution: 'Last Test Run',
        log_out: 'Sign Out',
        login: 'Sign In',
        logs: 'Logs',
        or: 'or',
        learn_more: 'Learn more',
        open_in_jira: 'Open in Jira',
        manage_teams: 'Manage Teams',
        manage_users: 'Manage Users',
        invite_user: 'Invite User',
        manage_projects: 'Manage Projects',
        recent: 'Recent Work',
        recent_project: 'RECENT',
        name: 'Name',
        offline: 'Offline',
        online: 'Online',
        organization: 'Organization',
        organizations: 'Organizations',
        organization_id: 'ID',
        organization_name: 'Name',
        organization_update: 'Update',
        organization_choose: 'Which organization would you like to upgrade?',
        organization_choose_free: 'Choose your organization',
        organization_choose_another: 'Select Another Plan',
        organization_choose_description: 'Please select an Organization to apply {{plan}}.',
        organization_transfer_ownership_warning: 'You’re transferring ownership of the Organization to another user.',
        organization_start: 'Start',
        organization_setting: 'Settings',
        organization_trial_request: 'Trial request for TestOps Business/Enterprise',
        organization_trial_request_nav: 'Trial Request',
        organization_start_create_team: 'Create a new team',
        organization_start_invite_user: 'Invite user',
        organization_start_update_org: 'Update Organization',
        organization_help: 'Help',
        organization_help_product_docs: 'Product documentation',
        organization_help_manage_licenses: 'Manage licenses',
        organization_help_manage_users: 'Manage users',
        organization_invitation_email_placeholder: 'Enter valid email addresses',
        organization_invitation_button: 'Invite',
        organization_invite_user_success: 'Invited {{totalEmails}} to {{organization.name}}.',
        execution_share_user_success: 'Test Run {{executionOrder}} has been sent successfully.',
        organization_update_user_role: 'Update',
        organization_update_user_role_success: 'The changes have been saved.',
        organization_assign_user_feature_success: 'The {{featureName}} license has been assigned to {{user.email}}.',
        organization_assign_user_feature_success_title: 'Successfully assigned!',
        organization_revoke_user_feature_success: 'The {{featureName}} license has been revoked from {{user.email}}.',
        organization_assign_plan_success: '{{orgName}} has been successfully assigned {{plan}}',
        organization_revoke_user_feature_success_title: 'Successfully revoked!',
        organization_add_sso_option_success: 'The request to enable SSO has been sent to this member.',
        organization_add_sso_option_success_title: 'SSO enabled',
        organization_remove_sso_option_success: 'This member will no longer be able to access Katalon TestOps via SSO.',
        organization_remove_sso_option_success_title: 'SSO disabled',
        organization_remove_user: 'Remove user',
        organization_remove_invitation: 'Remove invitation',
        'organization-configuration-integration-label': 'Upload execution reports',
        'organization-configuration-integration-description': 'When you disable this setting, all members in your' +
          ' Organization are not allowed to take the following action:',
        organization_session_timeout_header: 'Session Timeout',
        organization_session_timeout_title: 'Timeout value (in minutes)',
        organization_session_timeout_description: 'Leave the cell blank or input 0 to disable session timeout.',
        organization_update_session_timeout: 'Update',
        product_access: 'Product Access',
        failed_assertions: 'Failed Assertions',
        total_assertions: 'Total Assertions',
        sso_configuration: 'Login Settings',
        sso_authentication: 'Enable SSO',
        basic_authentication: 'Access Katalon TestOps with username & password',
        product_ks: 'Katalon Studio (Free)',
        product_kse: 'Katalon Studio Enterprise',
        product_kre: 'Katalon Runtime Engine',
        product_kto_center: 'Katalon Test Management (Beta)',
        product_kto_ci: 'Katalon Test Planning (Beta)',
        product_kto_reports: 'Katalon Test Analytics (Beta)',
        activation_link: 'Activation Link',
        create_organization: 'Create organization',
        go_to_home: 'Go to Home',
        create_new_organization: 'Create New Organization',
        create_organization_confirm: 'A new organization will be created. Click OK to confirm!',
        plans: 'Test Run Types',
        'plan#next_run': 'Next Run',
        'plan#last_run': 'Last Run',
        performance_trend: 'Performance Trend',
        performance: 'Performance',
        priorities: 'Priorities',
        profile: 'Profile',
        projects: 'Projects',
        project_profile: 'Project profile',
        project_dashboard: 'Dashboard',
        project_setting: 'Project Settings',
        project_id: 'ID',
        project_name: 'Name',
        project_update: 'Update',
        project_danger_zone: 'Danger zone',
        project_msg_delete_project: 'Once deleted, it will be gone forever. Please be certain.',
        project_button_delete: 'Delete this project',
        'project_dashboard#Overview': 'Overview',
        project_timezone_notice: 'The default time zone displayed in Katalon TestOps is the local time and in reports is UTC.',
        project_timezone_notice_cont: 'These settings are applied for time displayed in Katalon TestOps and future reports only.',
        quick_guide_header: 'Quick Guide',
        quick_guide: 'Import Test Results',
        releases: 'Releases',
        builds: 'Builds',
        osName: 'Operating System',
        browserName: 'Browser',
        'builds#create': 'Create Build',
        'builds#update': 'Update Build',
        release: 'Release',
        'release#version': 'Release version',
        'releases#create': 'Create Release',
        'releases#update': 'Update Release',
        'release#edit': 'Edit Release',
        'release#reopen': 'Reopen',
        'release#close': 'Archive',
        'release#start-time': 'Start Date',
        'release#end-time': 'Release Date',
        'release#totalExecution': 'Test Runs',
        'release#totalTestCase': 'Test Cases',
        remove: 'Remove',
        releases_populate: 'Populate Jira Releases',
        requests: 'Requests',
        result: 'Result',
        role: 'Role',
        run: 'Run',
        rerun: 'Re-run',
        reruns: 'Re-runs',
        run_plan: 'Run Plan',
        save: 'Save',
        save_and_publish: 'Save & Publish',
        'save-and-schedule': 'Save and Schedule',
        'save-and-run': 'Save and Run',
        submit: 'Submit',
        refresh: 'Refresh',
        refreshing: 'Refreshing',
        select_project: 'Select project',
        select_projects: 'Select projects',
        similar_failures: 'Similar Failures',
        status_trend: 'Status Trend',
        apply_filter: 'Apply',
        reset_filter: 'Reset',
        status: 'Status',
        steps: 'Steps',
        statistic: 'Statistics',
        teams: 'Teams',
        team_id: 'ID',
        team_name: 'Name',
        team_update: 'Update',
        team_transfer_ownership_warning: 'You’re transferring ownership of the Team to another user.',
        team_settings: 'Team Settings',
        team_profile: 'Team Profile',
        team_delete_btn: 'I understand the consequences, delete this team',
        team_invite_user_success: '{{totalEmails}} User(s) added successfully!',
        test_cases: 'Test Cases',
        active_projects: 'Active',
        archived_projects: 'Archived',
        'test_cases#all': 'All',
        'test_cases#slowest': 'Slowest',
        'test_cases#stale': 'Stale',
        'test_cases#active': 'Active',
        test_case: 'Test Case',
        'test_case#description_input_label': 'Description',
        'test_case#url_input_label': 'App URL',
        'test_case#url_empty_error': 'Please fill out this field',
        add_test_case: 'Test Case',
        'add_test_case#title': 'Create Test Case',
        default_test_case_name: 'New test case',
        'add_test_case#submit': 'Record Test Steps',
        'test_case_name#error_max_length': 'Max. 255 characters.',
        'test_case_name#error_start_with_special_char':
          'Only start with a letter, a number or an underscore (_).',
        'test_case_name#error_contain_special_char':
          'No special characters other than (),.-_ are allowed.',
        'test_case_name#error_contain_consecutive_dots': 'Not contain two consecutive dots (..).',
        'test_case_name#error_end_with_dot': 'Not end with a dot (.).',
        'test_case_name#error_duplicate': 'A test case with the same name already exists in this location.',
        'test_case_name#error_empty': 'Please fill out this field.',
        nameInvalidDotError: 'Invalid name! Name cannot contain \'..\' or end with \'.\'.',
        'folder_name#error_header': 'Folder name must:',
        'folder_name#error_start_with_special_char': 'Start with a letter, a number, or an underscore (_)',
        'folder_name#error_contain_special_char': 'Not contain special characters other than (),.-_',
        'folder_name#error_contain_consecutive_dots': 'Not contain two consecutive dots (..)',
        'folder_name#error_end_with_dot': 'Not end with a dot (.)',
        'folder_name#error_max_length': 'Not exceed 255 characters',
        record_test_case: 'Test Case',
        'record_test_case#title': 'Create Test Case',
        'record_test_case#submit': 'Record Test Steps',
        test_cloud_select_placeholder: 'Select TestCloud Environment',
        test_design: 'Test Design',
        test_environment_type: 'Test Environment type',
        test_plans: 'Test Plans',
        test_project_delete_confirm: 'This script repository will be permanently deleted.',
        test_project_delete_success: 'The script repository {{id}} was deleted.',
        test_project_delete_success_and_wait: 'The script repository {{id}} was deleted successfully. It might take a while to reflect the changes.',
        test_project_delete: 'Delete Script Repository',
        test_runs: 'Test Runs',
        test_result: 'Test Result',
        test_results: 'Test Results',
        test_run_calendar: 'Test Runs',
        msg_disabled_native_app: 'TestCloud Mobile Native App is a limited-offering feature. Please refer more details <a href="https://katalon-inc.my.site.com/katalonhelpcenter/s/article/Limited-Offering-Feature-Mobile-Native-Application-Tests-with-TestCloud" target="_blank" rel="noopener noreferrer">here</a>.',
        failed_test_results: 'Failed Test Results',
        all_test_results: 'All Test Results',
        test_suites_caption: 'All status retrieved from the most recent test run of each Test Suite.',
        test_suites: 'Test Suites',
        add_test_suite: '+ Test Suite',
        'add_test_suite#new': 'Test Suite',
        'add_test_suite#title': 'Create new Test Suite',
        'add_test_suite#cloud-studio': 'Cloud Studio Test Suite',
        'add_test_suite#katalon-studio': 'Katalon Studio Test Suite',
        url: 'URL',
        users: 'Users',
        createAndAdd: 'Create & Add',
        user_license: 'Katalon Studio Licenses',
        'user#title_change_password': 'Change Password',
        'user#change_password': 'Change Password',
        'user#old_password': 'Current password',
        'user#new_password': 'New password',
        'user#confirm_new_password': 'Confirm new password',
        'user#update_password': 'Update password',
        'user#error_new_password_diff_old_password': 'Password must differ from current password.',
        'user#error_password_do_not_match': 'Passwords do not match.',
        'user#require_password': 'Make sure it\'s at least 8 characters.',
        'user_license#trial_non_business_user': 'Katalon Studio Enterprise and Katalon Runtime Engine trial licenses are only available for business emails.',
        'user_license#trial_active': 'Your trial period for Katalon Studio Enterprise and Runtime Engine expires on',
        'user_license#create-kse-trial': 'Create Trial KSE Offline License',
        'user_license#create-kse-trial-title': 'Create Trial Katalon Studio Enterprise Offline License',
        'user_license#create-engine-trial': 'Create Trial KRE Offline License',
        'user_license#create-engine-trial-title': 'Create Trial Katalon Runtime Engine Offline License',
        'user-settings#testops-advanced-enabled': 'Advanced features enabled for this account.',
        'user-settings#testops-advanced-disabled': 'Advanced features disabled for this account.',
        schedule: 'Create Trigger',
        'schedule#cancel': 'Cancel',
        'schedule#save': 'Save',
        'schedule#enter-expression': 'Enter RegEx',
        'schedule#enter-expression-holder': 'Enter your RegEx here...',
        'schedule#invalid-regex': 'Invalid regular expression',
        'schedule#custom-os-version': 'Custom OS version',
        'schedule#custom-device-name': 'Custom Device Name',
        'schedule#delete-custom-os': 'Delete Custom OS',
        'schedule#delete-custom-device-name': 'Delete Custom Device Name',
        'schedule#delete-os-confirm': 'Are you sure you want to delete custom OS: {{osName}}?',
        'schedule#delete-custom-device-name-confirm': 'Are you sure you want to delete custom device name: {{deviceName}}?',
        'schedule#duplicate-config-error': 'A configuration with this value already exists. Please enter a different value to create a new configuration.',
        'schedule#next-time': 'Next Run',
        'schedule#start-time': 'From',
        'schedule#end-time': 'To',
        'schedule#when-to-run': 'When to run',
        'schedule#what-to-run': 'What to run',
        'schedule#where-to-run': 'Where to run',
        'schedule#how-to-run': 'How to run',
        'schedule#confirmation#without-start-time': 'Repeat every {{interval}} {{timeRange}} and end on {{endTimeFormat}}.',
        'schedule#confirmation#without-end-time': 'Start on {{startTimeFormat}} and repeat every {{interval}} {{timeRange}}.',
        'schedule#confirmation#without-start-time-and-end-time': 'Repeat every {{interval}} {{timeRange}}.',
        'schedule#confirmation': 'Start on {{startTimeFormat}}, repeat every {{interval}} {{timeRange}}, and end on {{endTimeFormat}}.',
        'schedule#interval': 'Interval',
        'schedule#interval-unit': 'Interval Unit',
        'schedule#active': 'Active',
        'schedule#interval_unit': 'Interval unit',
        'schedule#place-holder-name': 'Enter a name',
        'schedule#suggested-environments': 'SUGGESTED ENVIRONMENTS',
        'schedule#default-name': 'Untitled',
        'schedule#default-test-run-name': 'Untitled Test Run',
        'schedule#general-information': 'General Information',
        'schedule#input-kobiton-device-id': 'Input Kobiton device ID',
        'schedule#tooltip-execution-mode': 'Parallel execution is only compatible with Katalon Studio version 8.0 or later',
        'schedule#tooltip-integration': 'Only compatible with Katalon Studio version 8.0 or later',
        'schedule#testops-scheduler': 'Schedule Automated Test',
        'schedule#manual-trigger': 'Save Configurations',
        'schedule#manual-trigger-tooltip': 'Save these settings as a Schedule to trigger your tests manually',
        'schedule#select-environment': 'Select environment',
        'schedule#latest-kre-option': 'Latest',
        'schedule#kre-version-latest-9-option': 'Latest 9.x',
        'schedule#kre-version-latest-10-option': 'Latest 10.x',
        'schedule-v1#manual-trigger-tooltip': 'Save these settings without \'Schedule At\' section to trigger your tests manually',
        'schedule-v1#select-native-app#uploaded-on': 'Uploaded on',
        'schedule-v1#select-native-app#desc': 'Can’t find your preferred App from the list? ',
        'schedule-v1#select-native-app#click-here-to-upload': 'Click here to upload app',
        'schedule-v1#select-native-app#note': 'Currently we only support one app for all mobile environments.',
        'schedule-v1#warning#select-tsc': 'This Test Suite Collection doesn’t have Test Suite, please Refresh or select another one.',
        'schedule-v1#select-tunnel#desc': 'Can’t find your active tunnel from the list? ',
        'schedule-v1#select-tunnel#how-to-setup': 'How to set up TestCloud Tunnel? ',
        'schedule-v1#select-tunnel#checking': 'Checking your TestCloud Tunnel',
        'schedule-v1#select-tunnel#auto-select-tunnel': 'Auto-selected tunnel',
        'test-run-name': 'Name',
        'startup#create_account': 'Create Account',
        'startup#email': 'Email',
        'startup#fullName': 'Full name',
        'startup#password': 'Password',
        'startup#confirm_password': 'Confirm password',
        'startup#create_account_save': 'Getting Started!',
        start: 'Start',
        end: 'End',
        repeat: 'Repeat',
        every: 'Every',
        create: 'Create',
        update: 'Save',
        link: 'Link',
        'agent#agent-name': 'Agent Name',
        'agent#download-config': 'Download Agent Configuration',
        'agent#generate-api-key': 'Use an existing API key or create a new one ',
        'agent#api-key': 'Katalon API Key',
        'agent#ks-version': 'Katalon Studio Version',
        'agent#kre-version': 'Katalon Runtime Engine version',
        'agent#select-version': 'Select version',
        'agent#kre-location': 'Pre-Installed Katalon Runtime Engine Location',
        'agent#os': 'Agent OS',
        'agent#ks-location-rationale': 'Use this field when Katalon Studio cannot be downloaded automatically (often due to network conditions)',
        'agent#ks-location-example': 'e.g. /var/lib/jenkins/Katalon_Studio_Linux_64-5.10.1',
        'agent#remove': 'Delete Agent',
        'agent#selectOS': 'Select OS',
        'agent#downloadAgent': 'Download Agent',
        'agent#docs#learnMore': ' Learn more',
        'agent#step#download': 'Download an agent',
        'agent#step#config': 'Configure an agent',
        'agent#step#configCommand': 'Generate configuration',
        'agent#step#startCommand': 'Start an agent',
        'agent#step#create-plan': 'Schedule a test run',
        'agent#step#schedule-test-runs': 'Schedule test runs',
        'agent#step#assign-to-project': 'Assign to projects',
        'agent#create-local-test-env': 'Create Local Test Environment',
        'agent-local': 'Local Environment',
        'agent-docker': 'Docker Environment',
        'docker-compose': 'Docker Compose ',
        'docker-cli': 'Docker run command',
        'select-method': ' Select method',
        'docker-start-with': 'Start Docker Container with',
        'create-sample-plan': 'Schedule Sample Test Run',
        'create-plan': 'Schedule Test Run',
        'create-schedule': 'Schedule',
        'save-configuration': 'Save Configuration',
        'create-build': 'Create Build',
        'build#remove': 'Delete Build',
        'build#title': 'Build: {{-name}}',
        'create-sample-test-project': 'Create a Sample Script Repository',
        'git-test-project': 'Git Project',
        'ks-test-project': 'Katalon Studio Project',
        reports: 'Reports',
        planning: 'Planning',
        test_reports: 'All Reports',
        test_objects: 'Web Services',
        test_object_entities: 'Test Objects',
        test_object_entity: 'Test Object',
        platform_statistics: 'Platform Statistics',
        'web_services#abnormal': 'Anomalies',
        'test_objects#abnormal': 'API performance anomalies',
        'test_objects#abnormal-title': 'These web service calls took much less or much more time to response than usual.',
        test_objects_caption: 'All status retrieved from the most recent test run of each Test Object.',
        jira_setting: 'Jira Integration',
        'jira-setting#password-api-key': 'Password (Jira Server) / API Key (Jira Cloud)',
        'jira-setting#api-key-learmore': 'Learn more about Jira API key',
        'jira-setting#active-button': 'Active',
        'jira-setting#test-connection': 'Test Connection',
        'jira-setting#save': 'Save',
        'jira-setting#form-class': 'jiraFormClass',
        'jira-integration': 'Jira Integration',
        'jira-integration#enable': 'Enable Jira Integration',
        'jira-integration#details': 'Enable Jira Integration to view Jira releases.',
        'jira-integration-description': 'Katalon TestOps provides seamless integration with Jira that brings several benefits for team collaboration.',
        'jira-releases-description': 'You can add Jira Releases to Katalon TestOps to manage the testing schedule and monitor the Release readiness status effectively.',
        'jira-requirements-description': 'You can link Test Cases to Jira Stories to track the test coverage and to design new Test Cases more efficiently.',
        'jira-defects-description': 'You can link Test Results in Katalon TestOps to Jira Defects to provide more meaningful information for development team.',
        'jira-integration#active-connection-note': 'You need to fill in all information below to activate Jira integration.',
        kobiton_setting: 'Kobiton Integration',
        'kobiton-setting#api-key': 'Kobiton\'s API Key',
        'kobiton-setting#test-connection': 'Test Connection',
        'kobiton-setting#active-button': 'Active',
        'kobiton-setting#url': 'Kobiton Device URL',
        slack_setting: 'Slack Integration',
        'slack-setting#test-connection': 'Test Connection',
        'slack-setting#save': 'Save',
        'slack-setting#active-button': 'Active',
        analysis_settings: 'AnalysisSettings',
        'analysis#analyze': 'Analyze',
        'analysis#summary': 'Summary',
        'analysis#no_failed_results': 'No failed test results to analyze.',
        'analysis#status@running': 'Analyzing...',
        'analysis#status@finished': 'Failed test results have been analyzed. Click to try again.',
        'analysis#status@other': 'Click to classify the failed test runs and gather common failures into groups.',
        'analysis#category': 'Type',
        'analysis#total_failed_results': 'Frequency',
        'analysis#representative_result': 'Sample Result',
        'analysis#representative_error_log': 'Sample Error',
        'analysis#summarization': 'Error Summary',
        'analysis#occupied': 'Occupied (%)',
        'analysis#group_id': 'Group ID',
        'analysis#settings@auto_analysis': 'Auto Analysis',
        'analysis#settings@auto_analysis@active': 'Automatically analyze after execution submission',
        'analysis#settings@auto_analysis@inactive': 'Manually click Analyze button in Failed Result Analysis to proceed to analyze.',
        'analysis#settings@grouping_threshold': 'Grouping Threshold',
        'analysis#error-groups': 'Common Errors',
        'test-suite': 'Test Suite',
        'test-suite-collection': 'Test Suite Collection',
        'no-tsc': 'No Test Suite Collections.',
        'profile#fullname': 'Name',
        'profile#lastName': 'Last name',
        'profile#firstName': 'First name',
        'profile#email': 'Email',
        'file-preview#no-preview': 'We can\'t preview this file type.',
        'file-preview#try-download': 'Try downloading the file to view it.',
        saved_changes_success: 'The changes have been saved.',

        'comments#title': 'Comments',
        'comments#edit': 'Edit',

        subscriptions: 'Subscriptions',
        'subscription-management': 'Katalon Studio Subscription Management',
        'upgrade-subscription': 'Upgrade Subscription',
        'edit-subscription': 'Edit Subscription',
        'cancel-subscription': 'Cancel Subscription',
        'cancel-survey-title': 'Please complete this form to proceed',
        subscribe: 'Subscribe',
        'current-plan': 'Current Plan',
        upgrade: 'Upgrade',
        'contact-us': 'Contact us',
        'new-orders': 'New Orders',
        'testops-license': 'Activate License Server',
        'testops-license#placeholder': 'Paste your license here.',
        license: 'License',
        unassigned_subscriptions: 'Unassigned Subscriptions',
        assign_subscription: 'Assign Subscription',
        'assign_subscription#select_organization': 'Select organization to register',
        'assign_subscription#action': 'Action',
        created_at: 'From',
        expiration_date: 'Valid Until',
        'testops-free': 'TestOps Community',
        'current-subscription': 'Your current subscription',
        'subscription-term': 'Subscription Term',
        'up-to': 'Up to',

        payment: 'Payment Method',
        'payment#card_number': 'Card Number',
        'payment#expiration': 'Expiration',
        'payment#cvc': 'CVC',
        'payment#card_holder': 'Card Holder',
        'payment#pay_now': 'Pay now',
        'payment#add_card_success': 'Payment method added successfully.',
        'payment#update': 'Update',
        'payment#delete': 'Delete',
        'payment#delete_dialog@header': 'Delete permanently',
        'payment#billing_information': 'Billing Information',
        'payment#billing_information@ccEmails': 'CC Emails',
        'payment#billing_information@address1': 'Address line 1',
        'payment#billing_information@address2': 'Address line 2',
        'payment#billing_information@city': 'City',
        'payment#billing_information@state': 'State',
        'payment#billing_information@country': 'Country',
        'payment#billing_information@postal_code': 'Postal code',
        'payment#billing_information@vat_number': 'VAT/GSC ID',
        'payment#billing_information@full_business_name': 'Full business name',
        'payment#billing_information@save_changes_button': 'Save Billing Information',
        'payment#error_invalid_card': 'Your card number is invalid.',

        checkout: 'Checkout',
        get_quote: 'Get Quote',
        get_quote_success: 'Thank you! We\'ve received your request. We’ve just sent a confirmation email with a price quotation and a purchase instruction to your email and cc the emails configured in Billing Information.',
        get_quote_no_nonsubscribed_organizations: 'Unable to get quote. This feature is only applied for organizations without license purchase history.',

        'testOps-configuration#location': 'TestOps Location',
        'testOps-configuration#update': 'Update',
        'licenseServer#location': 'License Server Location',

        totalPassedTests: 'Passed',
        totalFailedTests: 'Failed',
        totalUnexecutedTests: 'Unexecuted',
        totalErrorTests: 'Error',
        totalIncompleteTests: 'Incomplete',
        totalSkippedTests: 'Skipped',
        testCaseStatus: 'Test Case Status',
        duration: 'Duration',
        elapsedDuration: 'Elapsed Duration',
        averageDuration: 'Average Duration',
        avgDuration: 'Avg. Duration',
        all_passed: 'Always Passed',
        all_failed: 'Always Failed',
        new_passed: 'Fixed',
        new_failed: 'Failed',
        startTime: 'Started',
        totalDuration: 'Total Duration',
        passedExecution: 'Passed Test Runs',
        failedExecution: 'Failed Test Runs',
        passed: 'Passed',
        failed: 'Failed',
        unsaved: 'Unsaved',
        failedTestCase: 'Failed Test Cases',
        passedTestCase: 'Passed Test Cases',
        totalAssertions: 'Assertions',
        passedJob: 'Passed Sessions',
        failedJob: 'Failed Sessions',
        errorJob: 'Error Sessions',
        totalJob: 'Total Sessions',
        totalAgent: 'Total Local Agent',
        totalK8sAgent: 'Total Kubernetes Agent',
        totalCircleCiAgent: 'Total Circle CI Agent',
        totalAgentDuration: 'Daily Duration',
        total: 'Total',
        username: 'Username',
        copyRequestParams: 'Copy as REST API',
        totalDefect: 'Total defects',

        'k8s-agent': 'Kubernetes',
        'k8s-agent#certificate-authority': 'Certificate Authority',
        'k8s-agent#authenticate-type': 'Authentication Type',
        'k8s-agent#password': 'Password',
        'k8s-agent#token': 'Token',
        'k8s-agent#namespace': 'Namespace',
        'k8s-agent#basic-auth': 'Username / Password',
        'k8s-agent#bearer-token': 'Token',
        'k8s-agent#eks-auth': 'AWS EKS',
        'k8s-agent#eks-region': 'Region',
        'k8s-agent#eks-cluster': 'Cluster',
        'k8s-agent#eks-access-key': 'Access Key',
        'k8s-agent#eks-private-access-key': 'Private Access Key',
        'k8s-agent#test-connection': 'Test Connection',
        'k8s-agent#create': 'Create',
        'k8s-agent#create-button': 'Create Kubernetes Test Environment',
        'k8s-agent#update': 'Update',
        'k8s-agent#title': 'Kubernetes',

        'circle-ci-agent': 'CircleCI',
        'circle-ci-agent#token': 'Personal API Token',
        'circle-ci-agent#branch': 'Branch',
        'circle-ci-agent#project': 'Followed Project',
        'circle-ci-agent#vcs-type': 'Version Control Type',
        'circle-ci-agent#test-connection': 'Test Connection',
        'circle-ci-agent#create': 'Create',
        'circle-ci-agent#create-button': 'Create CircleCI Test Environment',
        'circle-ci-agent#update': 'Update',
        'circle-ci-agent#title': 'CircleCI',
        'circle-ci-agent#connect': 'Connect',
        'circle-ci-agent#follow-project': 'Select the CircleCI project created in step 1',

        test_cloud_license_keys: 'Katalon TestCloud',
        'test_cloud_license_keys#subscription#parallel-tests': 'Parallel Tests',
        'test_cloud_license_keys#subscription#testing-time': 'Testing Time',
        'test_cloud_license_keys#subscription#unlimited-testing-time': 'Unlimited',
        'test_cloud_license_keys#subscription#unlimited-parallel-tests': 'Unlimited',
        'test-cloud-agent': 'TestCloud',
        'test-cloud-agent#plat-form': 'Platform',
        'test-cloud-agent#total-duration': 'Total duration',
        'test-cloud-agent#default-agent-for-tsc-message': 'If you do not override environment for a test suite in a test suite collection, it will be executed on a Linux instance with the latest versions of Chrome and Firefox installed.',
        'test-cloud-tunnel#setup': 'Setup',
        'test-cloud-tunnel#tunnels': 'Tunnels',
        'test-cloud-tunnel#selectOS': 'Select OS',
        'test-cloud-tunnel#download': 'Download',
        'test-cloud-tunnel#testingUrl': 'Your Testing Website URL',
        'test-cloud-tunnel#step#configCommand': 'Generate configuration',
        'test-cloud-tunnel#step#download': 'Download the binary file',
        'test-cloud-tunnel#step#config': 'Configure your tunnel',
        'test-cloud-tunnel#step#startCommand': 'Start a tunnel',
        'test-cloud-tunnel#step#execute': 'Execute your test run',
        'test-cloud-tunnel#share-description': 'Share TestCloud tunnel with members in your team.',
        'test-cloud-tunnel': 'Private/Local Testing',
        'test-cloud-tunnel#title': 'TestCloud Tunnels',
        'test-cloud-tunnel#tool-tip': 'TestCloud Tunnel lets you test your websites hosted in testing environments without hosting them on public environments',
        'test-cloud-tunnel#tunnelId': 'Tunnel ID',
        'test-cloud-tunnel#tunnelVersion': 'Tunnel Version',
        'test-cloud-tunnel#owner': 'Owner',
        'test-cloud-tunnel#duration': 'Duration',
        'test-cloud-tunnel#active': 'Active',
        'test-cloud-tunnel#sharedTunnel': 'Shared Tunnel',
        'test-cloud-tunnel#tunnelType': 'Tunnel Type',
        'test-cloud-tunnel#shared': 'Shared',
        'test-cloud-tunnel#private': 'Private',
        'test-cloud-tunnel#fail-get-active-tunnels': 'Cannot get active tunnels.',
        'test-cloud-tunnel#fail-get-api-keys': 'Cannot get api keys.',
        'test-cloud-local-testing': 'Private/Local Testing',
        'test-cloud-local-testing#description': 'Test your locally or privately hosted pages.',

        'test-cloud-local-testing#fail-get-active-tunnels': 'Error when get active tunnels.',
        'test-cloud-local-testing#enable-api-testing': 'Also include API calls',
        'test-cloud-local-testing#enable-api-testing#warn-message': 'Enabling this option for mixed UI and API testing but may slightly impact test execution time.',
        'test-cloud-stop-dialog#title': 'Stop Tunnel',
        'test-cloud-stop-dialog#content': 'Are you sure you want to stop this tunnel?',
        'test-cloud-stop-dialog#btn-stop': 'Stop',
        'test-cloud-stop-dialog#btn-cancel': 'Cancel',
        'test-cloud-stop-dialog#success-message': 'Tunnel Id {{id}} has been stopped.',
        'test-cloud-stop-dialog#fail-message': 'Cannot delete tunnel.',
        'test-cloud-session-summary#tooltip-message-organization': 'Number of running and queued TestCloud sessions in current Organization',
        'test-cloud-session-summary#tooltip-message-project': 'Number of running and queued TestCloud sessions in current Project',
        'test-cloud-session-summary#fail-message': 'Failed to get TestCloud Session Summary',
        'test-cloud-session-summary#multi-platform-tooltip': 'Limited legacy offering includes Desktop Browsers, Mobile Browsers, and Mobile Native Apps.',
        'test-cloud-session-summary#cross-browser-tooltip': 'Limited legacy offering includes Desktop Browsers and Mobile Browsers.',
        'test-cloud-session-summary#title-desktop-browser': 'Desktop Browser',
        'test-cloud-session-summary#title-desktop-mobile-browser': 'Desktop & Mobile Browser',
        'test-cloud-session-summary#title-mobile-native-app': 'Mobile Native App',
        'test-cloud-session-summary#title-multi-platform': 'Multi Platform',
        'test-cloud-session-summary#tite-summary-session': 'Running in Organization',
        'test-cloud-session-summary#show-details-button': 'Show details',
        test_cloud_validation_timeout_blank: 'This field is required. Value must be natural number between 10 and 999.',
        test_cloud_validation_timeout_invalid_value: 'Value must be natural number between 10 and 999.',

        'local-agent': 'Local',
        'msg#local-agent-inactive': 'Selected local agent is inactive',
        'test-env-installation': 'Agent Setup',

        totalSucceedJobs: 'Success',
        totalFailedJobs: 'Failed',
        totalPlannedJobs: 'Planned',

        feedbackTitle: 'Other ways to contact us',
        'feedback-tweet': 'Tweet',

        defects: 'Defects',
        jira_defect: 'Jira Defects (e.g. DEMO-1)',
        requirements: 'Requirements',
        requirement_details: 'Requirement',
        'requirements#testCaseTemplates': 'Test Cases',

        'home-org-license-management': 'License management',
        'home-org-user': 'User',
        'home-org-kse': 'Katalon Studio Enterprise',
        'home-org-kre': 'Katalon Runtime Engine',
        'home-org-license': 'License',
        'home-org-manage-user': 'Manage users',
        'home-org-purchase': 'Purchase',
        'home-org-team-management': 'Team management',
        'home-org-view-projects': 'View projects',
        'home-org-manage-team': 'Manage teams',
        'home-org-team': 'Team',
        'home-org-project': 'Project',
        'home-org-learn-more': 'Learn more',

        'test-report#application': 'Coverage',
        'test-report#test-execution': 'Test Execution',
        'test-report#test-maintenance': 'Test Maintenance',

        'number-of-test-runs-per-day-description': 'An analysis of the latest test run results on a daily/weekly/monthly basis.',
        'test-cases-executed-per-day-description': 'A number of executed test cases on a daily/weekly/monthly basis.',
        'total-execution-time-per-day-description': 'An analysis of the total execution time on a daily/weekly/monthly basis.',
        'traceability-report-description': 'Manage the relationship across requirements, test cases, defects.',
        'platform-statistics-description': 'Test case quality by OS and browser-basis.',
        'requirement-test-run-coverage-description': 'The quality of each requirement based on the status of the corresponding test result.',
        'flakiness-report-description': 'The most unreliable test cases.',
        'test-performance-description': 'Overall status and performance of test cases.',
        'execution-report-description': 'Distribution of test execution status.',
        'frequency-report-description': 'How often tests are run and their daily performance.',
        'test-cases-not-retrievable': 'Test cases aren’t retrievable from the execution data.',

        'test-performance': 'Summary by Test Result',
        'requirement-test-run-coverage': 'Test Run Coverage',
        'traceability-report': 'Traceability Matrix',
        'flakiness-report': 'Flaky',
        'platform-statistics': 'Platform Coverage',
        'execution-report': 'Summary by Test Run',
        'frequency-report': 'Run Frequency',
        'test-run-report-by-status': 'Test Run by Status',

        'settings-license-utilization': 'Product Utilization',
        'settings-license-utilization-desc': 'View usage dashboard of Katalon Studio and TestOps.',
        'settings-license-management': 'License Management',
        'settings-license-management-desc': 'Assign and monitor Katalon Studio.',
        'settings-switch-account': 'Switch Account',
        'settings-user-management': 'User Management',
        'settings-user-management-desc': 'Add and remove users.',
        'settings-payment-method': 'Payment Method',
        'settings-payment-method-desc': 'Update billing information.',
        'settings-subscription-management': 'Subscription Management',
        'settings-subscription-management-desc': 'Create a new order and upgrade subscriptions.',
        'settings-organization-management': 'Organization Management',
        'settings-organization-management-desc': 'Edit organization information and manage security.',
        'settings-support-management': 'Support Management',
        'settings-support-management-desc': 'Select members who can submit a ticket at support portal.',
        'settings-teams': 'Team Settings',
        'settings-teams-desc': 'Update team information and other security configurations.',
        'settings-projects': 'Project Settings',
        'settings-projects-desc': 'Update project information and other security configurations.',
        'settings-no-permission': 'These settings are accessible only for Organization Owners and Admins.',
        'settings-manage_teams': 'Team Management',
        'settings-manage_teams-desc': 'Create teams and manage teams.',
        'settings-manage_projects': 'Project Management',
        'settings-manage_projects-desc': 'Manage your project settings.',
        'settings-testops_homepage': 'TestOps Homepage',
        'settings-testops_homepage-desc': 'View summary of organization activities.',

        'settings-organization': 'Organization Setup',
        'settings-organization-desc': 'Configure environment for TestOps.',

        'settings-manage_e2etg': 'TrueTest',
        'settings-manage_e2etg-desc': 'Configure properties for TrueTest.',
        'true-test-configuration': 'TrueTest Configuration',

        'settings-user': 'User Settings',
        'settings-user-desc': 'User Settings',
        'settings-gitter': 'Gitter',
        'settings-gitter-desc': 'Gitter',
        'settings-feedback': 'Feedback',
        'settings-feedback-desc': 'Feedback',
        'settings-feature-requests': 'Feature Requests',
        'settings-feature-requests-desc': 'Feature Requests',
        'settings-bug-reports': 'Bug Reports',
        'settings-bug-reports-desc': 'Bug Reports',
        'settings-quick-guide': 'Quick Guide',
        'settings-quick-guide-desc': 'Quick Guide',
        'settings-documentation': 'Documentation',
        'settings-documentation-desc': 'Documentation',
        'settings-release-notes': 'Release Notes',
        'settings-release-notes-desc': 'Release Notes',
        'settings-community': 'Community Portal',
        'settings-community-desc': 'Community Portal',
        'settings-submit-a-ticket': 'Submit a Support Case',
        'settings-submit-a-ticket-desc': 'Submit a Support Case',
        'settings-logout': 'Sign Out',
        'settings-logout-desc': 'Sign Out',
        'settings-download-ks': 'Download Katalon Studio',
        'settings-download-ks-desc': 'Download Katalon Studio',

        'view-profile': 'View Profile',

        'stepper#back': 'Back',
        'stepper#next': 'Next',
        'stepper#finish': 'Finish',
        'stepper#reset': 'Reset',
        'stepper#skip': 'Skip',

        sso: 'Single Sign-On (SSO) Settings',
        'sso#enable': 'Enable SSO',
        'sso#metadata': 'Metadata',

        'strict-domain': 'Strict Domain',
        'strict-domain#update-btn': 'I understand the consequences, activate the strict domain',
        'strict-domain#enable-btn': 'Enable strict domain',
        'strict-domain#enable-confirm-btn': 'I understand the consequences, enable strict domain',
        'strict-domain#disable-btn': 'Disable strict domain',
        'strict-domain#disable-confirm-btn': 'I understand the consequences, disable strict domain',

        'organization-settings#delete-btn': 'I understand the consequences, delete this organization',

        'codeBox#copy': 'Copy',
        linkRelease: 'Link to a release',
        clearRelease: 'Clear this release',

        'view-all': 'View all',
        'view-details': 'View details',
        'view-requirements-reports': 'View detailed coverage analysis',

        'ci#dashboard': 'Summary',
        'ci#dashboard#nextRun': 'Next Runs',
        'ci#dashboard#upcomingJob': 'Upcoming Jobs',
        'ci#dashboard#totalJob': 'Total jobs executed',
        'testops-keyes': 'Visual Testing',
        visual_baseline_collections: 'Visual Baseline Collections',
        visual_baseline_collection: 'Visual Baseline Collection',
        select_baseline_collection: 'Select baseline collection',
        no_options_baseline_collection: 'Selected the auto-generated baseline collection',
        add_keyword_for_visual_testing: 'Add Keywords for Visual Testing for each Test Case',
        description_keyword_for_visual_testing: 'To use this function, you have to create this file in your project. Then you define your keyword to call “Verify checkpoint” in your testing script in order to use image comparison in Visual Testing.',
        no_options_baseline_collection_tooltip_content: 'If there is no baseline collection, a default one will be auto-generated',
        compare_baseline_collection: 'Baseline Collection',
        'test-management': 'Test Management',
        'test-results': 'Test Results',
        'continuous-testing': 'Test Execution',
        'testops-report': 'Reports & Analytics',
        'test-planning': 'Test Planning',
        tests: 'Tests',
        'report#executions': 'Executions',
        keyes: 'Vision',
        'keyes-executions': 'Visual Test Runs',
        'keyes#execution#checkpoints': 'Checkpoints',
        'keyes#execution#failed-checkpoints': 'Failed Checkpoints',

        'testops-config': 'Configurations',
        'configuration-tab': 'Configuration tab',

        baseline_collection: 'Visual Baselines',
        'baseline-detail-history': 'History',
        'baseline-detail-current': 'Current',
        'baseline-information': 'Baseline information',
        'baseline-revisions': 'Baseline Revisions',
        'baseline-images': 'Baseline Images',
        'baseline-images#editImage': 'Edit Image',
        'baseline-images#more': 'More',
        'baseline-latest-version': 'Latest Version',

        'org-dashboard-recentProject': 'Recent Projects',
        'org-dashboard-latestExecution': 'Latest Test Runs',
        'license_keys#process-running': 'Online Licenses',

        view_projects: 'View all projects',

        SCENARIO: 'Scenario',
        TEST_CASE: 'Test Case',

        'org-sso-pending-invitations': 'Pending SSO Invitations',
        'org-sso-remove-pending-invitation': 'Delete SSO authentication request',

        'download-execution#CSV': 'Comma-separated values (.csv)',
        'download-execution#XLSX': 'Microsoft Excel (.xlsx)',
        'download-execution#PDF': 'PDF (.pdf)',
        'download-execution#ZIP': 'Compress File (.zip)',
        'jira-issue#defect-added': 'Defect added successfully!',
        'jira-issue#requirement-added': 'Requirement added successfully!',
        'jira-issue#xray-test-added': 'The test is linked successfully!',
        'jira-issue#xray-test-title': 'Xray Test Issue (EG., TEST-123)',

        'data-table-with-chart#details': 'Details',

        gitter: 'Gitter',
        'view-in-jira': 'View on JIRA',

        'execution-status-comparison': 'Test Run Status Comparison',

        from: 'From',
        to: 'To',
        'to#lower-case': 'to',
        totalTestResult: 'Total Test Results',
        passedTestResult: 'Passed Test Results',
        failedTestResult: 'Failed Test Results',
        errorTestResult: 'Error Test Results',
        incompleteTestResult: 'Incomplete Test Results',
        skippedTestResult: 'Skipped Test Results',
        totalTestCase: 'Total Test Cases',
        net: 'Net',
        percent: 'Percent',

        maintainer: 'Maintainer',

        'remoteExecution#title': 'Remote Execution with Continuous Testing',
        'remoteExecution#description': 'Maximize the capacity of local servers and speed up the testing process by executing automation tests remotely.',
        'remoteExecution#environment#description': 'Set up a test environment to execute your test runs. If a Test Environment is a local machine, it has to be controlled by an Agent.',
        'remoteExecution#environment#button': 'Create Test Environment',
        'removeExecution#command#description': 'Create a script repository to store your test automation scripts. It can be a Git repository or a .zip file.',
        'removeExecution#command#button': 'Add Script Repository',
        'removeExecution#trigger#description': 'Schedule test runs to execute on your test environments.',
        advanced: 'Advanced Feature',
        'advanced#upgrade-advanced': 'Try Katalon TestOps Advanced (beta) now',

        'advanced#kubernetes#header': 'Kubernetes Environment Setup for Continuous Testing',
        'advanced#kubernetes#description': 'Seamless integration with Kubernetes to execute tests remotely. It is designed and built with ease of deployment and configuration in mind to let development teams focus on testing activities.',
        'advanced#kubernetes#feature#1#name': 'Seamless integration with Kubernetes',
        'advanced#kubernetes#feature#1#description': 'Katalon TestOps - Kubernetes integration is designed and built with ease of deployment and configuration in mind to let development teams focus on testing activities.',
        'advanced#kubernetes#feature#2#name': 'Orchestrate Deployment with Kubernetes',
        'advanced#kubernetes#feature#2#description': 'The platform can do everything from deploying them to monitoring their health and scaling them to meet your demand.',
        'advanced#kubernetes#feature#3#name': 'CI/CD Pipeline Optimization',
        'advanced#kubernetes#feature#3#description': 'By testing in parallel, you can run tests as soon as developers submit new code updates throughout the entire SDLC. Timely reporting and quick feedback in Katalon TestOps Advanced (beta) will also facilitate better communication between various departments.',

        'advanced#requirement-coverage#header': 'Advanced Analytics with Application/Test Design Reports',
        'advanced#requirement-coverage#description': 'Katalon TestOps Advanced (beta) provides various types of Application/Test Design Reports for you to have dynamic perspectives and an insightful look at your automated testing activities.',
        'advanced#requirement-coverage#feature#1#name': 'Requirement Coverage',
        'advanced#requirement-coverage#feature#1#description': 'Katalon TestOps Advanced (beta) provides you a quick view of particular requirements and their related task performance.',
        'advanced#requirement-coverage#feature#2#name': 'Quality Analysis',
        'advanced#requirement-coverage#feature#2#description': 'You can view test trends across all metrics such as teams, build or application, and platform or browser to determine where you focus your resources.',
        'advanced#requirement-coverage#feature#3#name': 'Real-Time Reporting and Metrics',
        'advanced#requirement-coverage#feature#3#description': 'You can view reports in real-time to have the most current available data at your disposal and adjust your testing strategy much faster.',

        'advanced#test-execution-frequency#header': 'Test Execution Reports',
        'advanced#test-execution-frequency#description': 'Katalon TestOps Advanced (beta) provides various types of Test Execution Reports for you to have dynamic perspectives and an insightful look at your automated test execution.',
        'advanced#test-execution-frequency#feature#1#name': 'Frequency Analysis',
        'advanced#test-execution-frequency#feature#1#description': '',
        'advanced#test-execution-frequency#feature#2#name': '',
        'advanced#test-execution-frequency#feature#2#description': '',
        'advanced#test-execution-frequency#feature#3#name': 'Real-Time Reporting and Metrics',
        'advanced#test-execution-frequency#feature#3#description': 'You can view reports in real-time to have the most current available data at your disposal and adjust your testing strategy much faster.',

        'advanced#default-template#header': 'Welcome to Katalon TestOps Advanced (beta)',
        'advanced#default-template#description': 'Extended Katalon TestOps Core with extensive features, advanced reports and analytics for development teams to optimize testing activities.',
        'advanced#default-template#feature#1#name': 'Unlimited Projects & Data History',
        'advanced#default-template#feature#1#description': 'Katalon TestOps Advanced (beta) provides you unlimited access to projects and test results for better test management.',
        'advanced#default-template#feature#2#name': 'Continuous Testing at scale',
        'advanced#default-template#feature#2#description': 'Katalon TestOps Advanced (beta) allows you to leverage the Kubernetes platform so that you can achieve scalable Continuous Testing.',
        'advanced#default-template#feature#3#name': 'Advanced Reports and Analytics',
        'advanced#default-template#feature#3#description': 'Katalon TestOps Advanced (beta) provides actionable reports, metrics, and real-time insights to help you have a better look at your testing progress.',

        'trialRequest#version': 'Deployment',
        'trialRequest#name': 'Your name',
        'trialRequest#email': 'Your business email',
        'trialRequest#company': 'Your company',
        'trialRequest#businessTitle': 'Your business title',
        'trialRequest#address': 'Street address',
        'trialRequest#city': 'City',
        'trialRequest#postalCode': 'Postal code',
        'trialRequest#country': 'Country',
        'trialRequest#totalTester': 'How many automation testers/engineers in your team?',
        'trialRequest#totalPeople': 'How many people are using Katalon TestOps in your team?',
        'trialRequest#timeToAppliedTO': 'How long has your team applied Katalon TestOps to your projects?',
        'trialRequest#productUsed': 'Which Katalon products are you currently subscribing to?',
        'trialRequest#notice': 'Note: This request is applied for a 45-day trial on the Cloud version only. For On-premises deployment, please contact us via business@katalon.com.',
        'trialRequest#featureTrial': 'Select a package to trial. See ',
        package_details: 'package details',
        'trialRequest#testOpsBusiness': 'TestOps Business (30-day trial)',
        'trialRequest#testOpsEnterprise': 'TestOps Enterprise (45-day trial)',
        testOpsBusiness: 'TestOps Business',
        testOpsEnterprise: 'TestOps Enterprise',
        'trialRequest#free': 'TestOps Free',
        'trialRequest#bussiness-success': 'You have successfully registered for \r\nTestOps Business 30-day Trial.',
        'trialRequest#enterprise-success': 'You have successfully registered for \r\nTestOps Enterprise 45-day Trial.',
        'trialRequest#visual-testing-pro-success': 'You have successfully registered for \r\nVisual Testing Professional 30-day Trial.',
        'trialRequest#explore-button': ' Let\'s explore',
        'share-report': 'Share Test Run Report via Email',
        'share-reports': 'Share Reports',
        'share-report-question': 'Are you sure you want to share report to following email(s)?',
        'share-report-list': 'You are sharing report to:',
        'share-report-warning': 'This action cannot be undone.',
        'share-confirmation': 'Yes, share it',
        share: 'Share',
        send: 'Send',
        'report#automaticUpload': 'Automatically Upload Reports',
        'report#manualUpload': 'Manually Upload Reports',
        'report#JunitFromDevice': 'Upload JUnit reports from your device',
        'report#KatalonFromDevice': 'Upload Katalon reports from your device',
        'report#uploadReports': 'Upload Reports',
        'active-projects': 'Active Projects',
        'archived-projects': 'Archived Projects',
        'plugin#step#learn-more': 'Learn more',
        'plugin#importReport': 'Import reports',
        'plugin#importReport#description': 'Use the following command to run your tests and upload reports.',
        'junit#test#environment': 'JUnit Test Environment',
        'java#dependency': 'Configure a Dependency',
        'java#properties': 'Configure properties',
        'java#properties#description': 'Create testops.properties file in the src/test/resources',
        'testng#test#environment': 'TestNG Test Environment',
        'mocha#test#environment': 'Mocha Test Environment',
        'cypress#test#environment': 'Cypress Test Environment',
        'jest#test#environment': 'Jest Test Environment',
        'jasmine#test#environment': 'Jasmine Test Environment',
        'pytest#test#environment': 'Pytest Test Environment',
        'robot#test#environment': 'Robot Test Environment',
        'protractor-jasmine#test#environment': 'Protractor Jasmine Test Environment',
        'protractor-mocha#test#environment': 'Protractor Mocha Test Environment',
        today: 'Today',
        month: 'Month',
        week: 'Week',
        day: 'Day',
        monthly: 'Monthly',
        weekly: 'Weekly',
        daily: 'Daily',
        'import-manual-reports': 'Import Manual Reports',
        agenda: 'Timeline',
        testing_activites: 'Test Activities',
        release_readiness: 'Release Readiness',
        create_git_script_repository: 'Create Git Script Repository',
        create_script_repository: 'Create Script Repository',
        connect_git_script_repository: 'Connect Git Repository',
        create_sample_script_repository: 'Create Sample Script Repository',
        details: 'Details',
        summary: 'Summary',
        type: 'Type',
        key: 'Key',
        attachments: 'Attachments',
        text_view: 'Text view',
        tree_view: 'Tree view',
        descriptions: 'Descriptions',
        errors: 'Errors',
        'test-case-with-requirements': 'Test Cases With Requirements',
        'test-case-without-requirements': 'Test Cases Without Requirements',
        'katalon-studio-integration': 'Katalon Studio Integration',

        annual: 'Annual',
        'studio-subscription': 'Studio Subscriptions',
        'testops-subscription': 'TestOps Subscriptions',
        'testops-subscription-management': 'Katalon TestOps Subscription Management',
        'testops-trial-request': 'Katalon TestOps Trial Request',
        'estimate-price': 'Estimate your price',
        'choose-test-run-calc-price': 'Select your monthly test results to calculate your price.',
        'number-monthly-test-result': 'Number of Monthly Test Execution',
        'feature-test-run': 'Test Results included',
        'feature-users': 'Users',
        'feature-storage': 'Storage',
        'feature-parallel-execution': 'Parallel execution',
        'feature-test-planning': 'Test planning',
        'feature-test-management': 'Test management',
        'feature-3rd-integration': '3rd-party integration',
        'feature-report-analytics': 'Report & Analytics',
        'feature-on-premise': 'On-Premise',
        'feature-single-sign-on': 'Single sign-on',
        'feature-ip-whitelisting': 'IP whitelisting',
        'feature-dashboard-custom': 'Dashboard customization',
        'feature-support': 'Support',
        features: 'Features',
        'coming-soon': 'Coming soon',
        'save-money': 'Save {{discount}}',
        buildLabel: 'Build Label',
        build: 'Build',
        'release-summary#day-to-delivery': 'Days to delivery',
        'release-summary#overdue': 'Overdue',
        'release-summary#days-left': '{{daysLeft}} day(s) left',
        'no-result': 'No results',
        'release-summary#development': 'Development',
        'release-summary#test': 'Test',
        katone_view_usage: 'View usage tracking',
        katone_error_title: 'Cannot connect to KatOne Server',
        katone_error_invalid_page: 'Invalid redirect page.',

        maintenance_warning: 'Our site is currently read-only while we do some maintenance. We apologize for any inconvenience. Please try again later.',
        maintenance_warning_login: 'Our site is currently under maintenance.\r\nPlease try again later.',
        standby_warning: 'The action might be delayed because the site is in read-only mode.',

        testcloud_free_trial_warning: 'Your TestCloud free trial will be expired in',
        testcloud_expired_message: 'Your TestCloud free trial has expired. You can not schedule test runs in TestCloud environment.',
        testcloud_buy_license: 'Buy TestCloud License',
        testcloud_learn_more: 'Learn more about TestCloud',
        testcloud_contact_an_expert: 'Contact an expert.',
        testcloud_contact_sales: 'Contact Sales.',

        'testcloud-execution#new-execution': 'You have created a new execution.',
        'testcloud-execution#view-detail': 'View {{testRunName}}.',

        organization_exceed_quota_warning: 'You are at {{usageOverQuota}}% of your monthly test result quota.',
        view_usage_quota: 'View your usage quota here.',
        wait_for_export: 'Exporting...',
        send_mail_for_export: 'Export is taking longer than usual. We have sent the download link via email to {{-email}}.',
        view_analysis: 'View analysis',
        add_card: 'Add new card',
        'report#prepare-message': 'Your report is being prepared.',
        'report#cannot-parse': 'Cannot generate report. Please try again.',
        'last-update': 'Last updated',
        'billing-summary': 'Billing Summary',
        'billing-cycle': 'Billing cycle',
        'no.-test-execution': 'No. of Test Execution',
        katalon_testops_pricing: 'Katalon TestOps Pricing',
        katalon_pricing: 'Katalon Pricing',
        'testops-trial-plans': 'TestOps Trial Plans',
        katalon_organization_choose: 'Please select an Organization to purchase Katalon Studio licenses.',
        upgrade_request: 'Please upgrade to {{subscription}} plan to access.',
        upgrade_request_new: 'Please upgrade to {{subscription}} plan to access. For more \r\ninformation on our subscription plans, please visit \r\n',
        upgrade_request_for_premium_plan: 'This feature is limited to the Premium and Ultimate plans of Katalon Platform.\r\nPlease upgrade your subscription plan to access. See: ',
        upgrade_trial: 'Please subscribe to Katalon {{subscription}} plan to access. \r\nTo request a trial, see ',
        TESTOPS_ENTERPRISE: 'Enterprise',
        TESTOPS_BUSINESS: 'Business',
        UNRELEASED: 'Unreleased',
        RELEASED: 'Released',
        EMPTY: 'Empty',
        NOT_READY: 'Not ready',
        READY: 'Ready',
        contact_sales: 'Contact Sales',
        'accept_invitation.invalid_token.title': 'Oops! There\'s something wrong with this invitation.',
        'accept_invitation.invalid_token.info': 'It looks like you\'re trying to accept this invitation, but the invitation is invalid now.',
        'accept_invitation.invalid_token.contact': 'Please contact your Organization admin for more information.',
        security: 'Security',
        email_server_configuration: 'Email Server Configuration',
        active: 'Active',
        archived: 'Archived',
        'no-billing-management-permission': 'You don\'t have permission to manage billing for this organization.',
        'applied-discount-code': 'Applied discount code: {{coupon}}',
        katalon_testops: 'Katalon TestOps',
        katalon_studio: 'Katalon Studio',
        katalon_studio_platform_edition: 'Katalon Studio - Platform Edition',
        katalon_studio_standalone_edition: 'Katalon Studio - Standalone Edition',
        download_studio: 'Download Studio',
        'payment-success#subscribed-info': 'You have subscribed to {{packageType}} licenses.',
        'payment-success#subscribed-invoices': 'An invoice has been sent to the Owner and Billing Manager of this organization.',
        'payment-success#thanks': 'Thank you for the purchase!',
        'assign-licenses': 'Learn how to assign licenses',
        'login-to-testops': 'Log in to Katalon TestOps',
        'advanced-setting': 'Advanced settings',
        integration: 'Integration',
        'place-holder-datetime': 'mm/dd/yyyy hh:mm',
        'testops-trigger': 'TestOps Trigger',
        date_modified: 'Date Modified',
        'list-organizations-and-projects#current': 'Current',
        'list-organizations-and-projects#all': 'All',
        'list-organizations-and-projects#loading-projects': 'Loading projects...',
        'refresh-jira-release-status-title': 'Refresh for latest release status from Jira',
        'refresh-jira-release-status-success': 'It might take a while for your latest data to show.',
        'refresh-jira-issue-of-project': 'It will take a few minutes to refresh. You need to reload the page to see the latest data.',
        'refresh-jira-issue-of-project-success': 'All linked JIRA issues have been synced successfully.',

        'test-runs#title-change-status': 'Change Test Result Status',
        'test-runs#action-change-status': 'You are changing status of Test Result {{testRunId}} from',
        'test-runs#option-change-status': 'Select a reason for changing the status',
        'test-runs#option-manual-result': 'Based on manual test result',
        'test-runs#option-expected-result': 'It matches expected result',
        'test-runs#option-flaky-test': 'It tends to get flaky by automation',
        'test-runs#option-updated-function': 'Functions have updates',
        'test-runs#option-other-option': 'Other',
        'test-runs#no-select': 'Select a reason to submit',
        'test-runs#other-option-null': 'This description field is required',
        'test-runs#other-option-max-length': 'Max 250 characters',
        'test-runs#other-option-placeholder': 'Please specify your reason, 250 characters max.',
        'test-runs#notification-success': 'The Test Result: {{testRunId}} has been marked as {{changeStatus}}.',
        'test-runs#notification-error': 'Something wrong happened, please try again later',
        view_changes_log: 'View changes log',
        original_result: 'Original result',
        latest_result: 'Latest result',
        changed_by: 'Changed by: {{-name}}',
        'left-nav#user-management': 'User Management',
        'left-nav#license-management': 'License Management',
        'left-nav#product-utilization': 'Product Utilization',
        'test-run-title': 'All Test Runs',
        number_of_test_runs: 'Number of Test Runs',
        update_test_project_success: 'It might take a while for your Test Suite Collection to show.',
        'test-execution#execution-title': 'Executions',
        'test-execution#histories': 'History',
        'test-execution#test-run-calendar': 'Calendar',
        'test-execution#test-run-list': 'Schedules',
        'test-execution#apps': 'Application Repository',
        'uploading-your-data': 'uploading your data',
        'setting-up-script-repository': 'setting up script repository',
        'draft-test-cases': 'Draft Test Cases',
        'edit-test-steps': 'Edit Test Steps',
        'view-steps': 'View Steps',
        'gen5-beta-chip': 'Beta',
        'test-steps': 'Test Steps',
        'uploaded-data': 'Uploaded Data',
        last_executed: 'Last executed',
        last_updated: 'Last updated',
        created_on: 'Created on',
        updated_on: 'Updated on',
        properties: 'Properties',
        'search#test-case': 'Search test case',
        'search#test-suite': 'Search by name test suite',
        'search#test-run': 'Search test run',
        'search#application-name': 'Search by Application Name',
        'search#placeholder-test-case-linking': 'Select test case to add to this Test Suite',
        'search-bar#maintainer': 'Maintainer',
        'search-bar#placeholder-maintainer': 'Select maintainer',
        'search-bar#requirement': 'Requirement',
        'search-bar#placeholder-requirement': 'Select requirement',
        'search-bar#placeholder-path': 'Input path',
        'search-bar#last-updated': 'Last updated',
        'search-bar#last-executed': 'Last executed',
        'search-bar#place-holder-datetime': 'mm/dd/yyyy',
        'search-bar#clear': 'Clear',
        'search-bar#update': 'Update',
        'search-bar#apply-and-search': 'Apply and search',
        'search-bar#flakiness': 'Flakiness (%)',
        'search-bar#tag': 'Tags',
        'search-bar#placeholder-tag': 'Find tags',
        'search-bar#more-than': 'More than',
        'search-bar#average-duration': 'Average Duration (mins)',
        'search-bar#less-than': 'Less than',
        'search-bar#duration-placeholder': 'mins',
        'search-bar#all-filters': 'All filters',
        'search-bar#add-more': 'Add more',
        'sort-name-asc': 'Sort A to Z',
        'sort-name-desc': 'Sort Z to A',
        'sort-asc': 'Sort in ascending order',
        'sort-desc': 'Sort in descending order',
        path: 'Path',
        'create-offline-license-warning-usesing': 'WARNING: ',
        'create-offline-license-offline-licenses': 'Offline licenses ',
        'create-offline-license-are-for-using': 'are for using KSE and KRE Node-locked without an internet connection. Please consider carefully because once generated, ',
        'create-offline-license-a-node-locked': 'a node-locked offline license:',
        'create-offline-license-cannot-be-revoked': 'Cannot be revoked or transferred to a different machine until its expiry date.',
        'create-offline-license-cannot-be-used': 'Cannot be used in dynamic machineID environments (Docker, Azure, AWS)',
        'create-offline-license-still-not': 'Still not sure if you need a node-locked offline license? Please submit ',
        'create-offline-license-so-we-can-assist': 'so we can assist.',
        'create-offline-license-submit-ticket': 'submit a support ticket ',
        'create-offline-license-machine-instruction': 'Input your machine ID on which you or your team member will use the KSE/KRE Offline license. Please refer to the screenshots on how to get your machine ID. Still not sure? Create a Test License file to ensure you got the correct machine ID',
        'create-offline-license-machine-date-instruction-you-cannot': 'You cannot revoke or transfer the license to another machine until this expiry date. ',
        'create-offline-license-machine-date-instruction-setting': 'Setting a short expiration date is recommended in case broken machines or changing new devices. ',
        'create-offline-license-popup-create-this-offline': 'This offline license cannot be revoked or transferred to a different machine until its expiry date and cannot be used in dynamic machine ID environments.',
        'create-offline-license-popup-please-confirm': 'Please confirm your ',
        'create-offline-license-popup-machine-id': 'Machine ID ',
        'create-offline-license-popup-expiry-date': 'Expiry date ',
        'create-offline-license-popup-are-correct': 'are correct.',
        'create-offline-license-popup-title': 'Create an offline license',
        'create-offline-license-popup-label-and': ' and ',
        'create-offline-license-popup-to-make-sure': 'To make sure, please confirm:',
        'create-offline-license-popup-create-btn': 'Create',
        'create-offline-license-popup-cancel-btn': 'Cancel',
        'warning-system-maintenance': 'On Jan 16, 2022 between the hours of 18:00 ICT - 18:20 ICT (1/16/22 06:00 - 06:20 EST), Katalon will perform back-end system maintenance that will impact authentication capabilities. Please monitor ',
        'warning-system-maintenance-this-page': 'this page',
        'warning-system-maintenance-during-the-time': ' during the times noted for updates on status.',
        'warning-katalon-platform-maintenance': 'The Katalon platform is scheduled for maintenance from Oct 22, 1:00 PM ICT (or Oct 22, 02:00 AM ET) to Oct 22, 5:00 PM ICT (or Oct 22, 06:00 AM ET). During this window, your experience may be affected. We apologize for any inconvenience.',
        'tree-view#refresh-test-case-noti': 'The script repository is being refreshed. It might take a while to show the latest data.',
        'download-ks-package': 'Download Katalon package',
        'download-ks#title_old': 'Start testing with the Katalon Platform',
        'download-ks#title': 'Start automation testing with Katalon!',
        'download-ks#platform-edition': 'Platform Edition',
        'download-ks#standalone-edition': 'Standalone Edition',
        'download-ks#platform-edition#title': 'Integrated with Katalon Platform for advanced test report and test management features.',
        'download-ks#standalone-edition#title': 'Suitable for authoring and executing tests locally.',
        'download-ks#ks-platform-description-old': 'Our primary authoring solution that seamlessly integrates with the Katalon Platform.',
        'download-ks#ks-platform-description': 'Fully integrated with the Katalon Platform for ease of use with all platform capabilities.',
        'download-ks#ks-standalone-description-old': 'A git-independent authoring tool suited for offline & on-premise testing environments.',
        'download-ks#ks-standalone-description': 'For standalone desktop authoring of tests. Git and Platform integration available but not required.',
        'download-ks#ks-description': 'Easily write automated tests, import your Selenium projects, and get started in minutes with our low-code IDE.',
        'download-ks#re-description-old': 'Execute tests in CI/CD pipelines or via the command-line interface.',
        'download-ks#re-description': 'Enables test execution via CI/CD integration or via command-line interface.',
        'download-ks#re-tooltip': 'When you activate the Studio trial license, the Runtime Engine 30-day trial will also be activated.',
        'download-ks#outdated-edition-information': 'We no longer support Windows 32bit.',

        test_suite_name: 'Test Suite Name',
        'test-suite-update#notification-success': 'Your test suite {{name}} was updated successfully',
        'test-suite-update#notification-empty-test-cases': 'The test suite needs at least one test case',
        'test-suite-create#notification-success': 'Test suite {{name}} was created successfully',
        run_with: 'Run with',
        'browser-type#chrome': 'Chrome',
        'browser-type#mobile-browsers': 'Mobile Browsers',
        'browser-type#mobile-native': 'Mobile Native App',
        'browser-type#mobile-native-optional': 'Mobile Native App (Optional)',
        'browser-type#all': 'All',
        'browser-type#chrome-headless': 'Chrome (headless)',
        'browser-type#firefox': 'Firefox',
        'browser-type#firefox-headless': 'Firefox (headless)',
        'browser-type#safari': 'Safari',
        'browser-type#edge': 'Edge',
        'browser-type#edge_chromium': 'Edge Chromium',
        'browser-type#ie': 'Internet Explorer',
        'browser-type#chromium': 'Chromium',
        'browser-type#web-services': 'Web Services',
        'browser-type#web-services-linux-default': 'Web Services (TestCloud Linux Default)',
        'os-name#windows': 'Windows',
        'os-name#linux': 'Linux',
        'os-name#iOS': 'iOS',
        'os-name#mac-os': 'MacOS',
        'os-name#android': 'Android',
        'device-type#tablet': 'Tablet',
        'device-type#phone': 'Phone',
        'device-type#iphone': 'iPhone',
        'device-type#ipad': 'iPad',
        execution_profile: 'Profile',
        'test-suite-detail#delete-test-suite': 'Delete Test Suite',
        'test-suite-detail#delete-test-suite-content': 'You\'re about to permanently delete this test suite. This action can\'t be undone.',
        'test-suite-detail#delete-test-suite-toast-message': 'The test suite was deleted successfully. It might take a while to reflect the changes.',

        view_demo_site: 'View Demo Site',

        'acknowledge-reimport-execution-title': 'Acknowledgement',
        'acknowledge-reimport-execution-content': 'Since you have already exceeded your monthly checkpoint quota, visual checkpoints will not be re-imported if you re-import the test run.',

        'read-only-mode#error-message': 'The action can’t be completed because the site is in read-only mode.',
        'show-data': 'Showing data for',
        'profile-coverage-title': 'Profile Coverage',
        'execution-trend-title': 'Execution Trend',
        'profile-coverage-by-test-run': 'By Test Run',
        'profile-coverage-by-test-result': 'By Test Result',
        'execution-trend-by-test-run': 'Test Run Execution Trend',
        'execution-trend-by-test-result': 'Test Result Trend',
        'execution-trend-by-test-result-tooltip-old': 'Total number of Incomplete, Error, Failed and Passed Test Results by selected time frame.',
        'execution-trend-by-test-result-tooltip': 'Total number of Incomplete, Error, Skipped, Failed and Passed Test Results by selected time frame.',
        'profile-coverage-by-test-run-tooltip': 'Total number of Passed and Failed Test Runs in each corresponding profile.',
        'profile-coverage-by-test-result-tooltip-old': 'Total number of Passed, Failed, Error and Incomplete Test Results in each corresponding profile.',
        'profile-coverage-by-test-result-tooltip': 'Total number of Passed, Failed, Error, Incomplete and Skipped Test Results in each corresponding profile.',
        'result-filter-all-results': 'All Results',
        'result-filter-latest-result': 'Latest Result',
        'overview-report#platform-coverage': 'Platform Coverage',
        'overview-report#platform-coverage#tooltip': 'Quality of Test Runs or Test Results in each corresponding Operating System and Browser.',
        'overview-report#platform-coverage#tooltip-undefined-browser': 'The undefined Browsers where the Test Runs or Test Results were executed.',
        'overview-report#platform-coverage#tooltip-undefined-os': 'The undefined Operating Systems where the Test Runs or Test Results were executed.',
        'overview-report#execution-trend-test-run#tooltip': 'Total number of Passed and Failed Test Runs by selected time frame and their associated total duration by that time frame.',
        'project-dashboard#platform-coverage#tooltip': 'Quality of Test Runs or Test Results in each corresponding Operating System and Browser in the Project.',
        'project-dashboard#total-test-run#tooltip': 'Total number of Test Runs and their associated total duration in the Project. Incomplete Test Runs will be excluded in the chart.',
        'project-dashboard#total-test-run': 'Total Test Runs',
        'project-dashboard#productivity': 'Productivity',
        'project-dashboard#test-cases-created': 'Test Cases Created',
        'project-dashboard#test-cases-created#tooltip': 'Total number of Test Cases created in the Project.',
        'project-dashboard#requirement-coverage': 'Requirement Coverage',
        'project-dashboard#requirement-coverage#tooltip': 'Quality of each Requirement based on the status of the corresponding Test Result.',
        'project-dashboard#quality': 'Quality',
        'project-dashboard#flaky': 'Flaky Test Distribution',
        'project-dashboard#flaky#tooltip': 'Distribution of Test Cases by their flakiness probability.',
        beta: 'Beta',
        'number-of-test-case': 'Number of Test Cases',
        'flakiness-%': 'Flakiness (%)',
        'project-dashboard#execution-result': 'Execution Result',
        'project-dashboard#execution-result#tooltip': 'Total Execution Time, Test Results and Test Cases execution results in the Project.',
        'project-dashboard#execution-time': 'Execution Time',
        'since-last-week': 'since last week',
        'since-previous-period': 'since previous period',
        'mark-as-failed': 'Mark as Failed',
        'mark-as-passed': 'Mark as Passed',
        pixel: 'Pixel',
        layout: 'Layout',
        content: 'Text Content',
        baseline: 'Baseline',
        checkpoint: 'Checkpoint',
        'identical-tooltip': 'Show UI zones from both images that are identically rendered.',
        'distinguishable-tooltip': 'Show UI zones that look identical for most parts but have some recognizable distinctions.',
        'new-missing-tooltip': 'Show UI zones that exist in one image and not in the other.',
        'matched-zone': 'Matched Zones',
        'diff-part-zone': 'Different parts in matched zones',
        'diff-zone': 'Different zones',
        'identical-zone-tooltip': 'Highlight texts with exact content and positions between the two images.',
        'shifted-zone-tooltip': 'Highlight texts with exact content but at different positions in the two images.',
        'missing-new-zone-tooltip': 'Highlight texts existing in either of the images but not both.',
        'identical-zone': 'Identical',
        'shifted-zone': 'Shifted',
        'missing-new-zone': 'Missing/New',
        'ignored-zones': 'Ignored Zones',
        'ignored-zones-tooltip': 'Ignore areas that are supposed to have dynamic and changing contents.',
        identical: 'Identical',
        distinguishable: 'Distinguishable',
        'new-missing': 'Missing/New',
        'comparison-method': 'Comparison method',
        'no-checkpoint-image': 'No checkpoint image',
        'no-baseline-image': 'No baseline image',
        others: 'Others',
        'project-dashboard#local-test-environments#tooltip': 'The total number of Agents by status and OS',
        'project-dashboard#local-test-environments#title': 'Local Test Environment',
        'project-dashboard#local-test-environments#view-all': 'View all',
        'project-dashboard#release-readiness#tooltip': 'Development, testing, and build progress of two most recent releases and the total number of defects for each release.',
        diffs: 'Diffs',
        'visual-testing#alert1': 'Layout and Text Content comparison methods cannot be applied to the images created prior to May 09, 2022 (ICT). Please re-import the Visual Test Run to re-new the images.',
        trial: 'Trial',
        'visual-testing#pro#badge-title': 'Pro',
        'visual-testing#welcome#title': 'Welcome to Katalon Visual Testing!',
        'visual-testing#welcome#content': 'Easily compare images captured during test executions',
        'visual-testing#welcome#setup': 'Set up Visual Testing',
        'baseline-collection-group-detail#title-id': 'ID:',
        'baseline-collection-id': 'Baseline Collection ID',
        'latest-version': 'Latest Version',
        'number-of-images': 'Number of Images',
        'test-schedules': 'Schedules',
        'delete-baseline-image': 'Delete this baseline image',
        'visual-testing#remove-baseline': 'Remove Baseline',
        'visual-testing#remove-baseline#description': 'This action cannot be undone. Are you sure you want to remove the following',
        'visual-testing#remove-baseline#success': 'The baseline {{selectedImageName}} has been removed. Baseline collection is updated to {{version}}.',
        'visual-testing#edit-baseline#configIgnoredZones': 'Configure Ignored Zones',
        'visual-testing#edit-baseline#description': 'Drag to choose to ignore areas that are supposed to have dynamic and changing contents.',
        'visual-testing#max-ignored-zones': 'It exceeds the limitation of 20 ignored zones.',
        'updated-by': 'Updated by',
        'baseline-collection-group-detail#title': 'Visual Baseline Collection: #{{order}}',
        'baseline-collection-group-history#title': 'Visual Baseline Collection History: #{{order}}',
        latest: 'Latest',
        'compared-to-baseline-collection': 'Compared to Baseline Collection:',
        save_changes: 'Save Changes',
        visual_testing_save_success: 'New ignored zone(s) created. Baseline collection is updated to v.{{version}}.',
        'notification-title#success': 'Success!',
        'pagination-text': 'Total: {{totalItem}} {{unitName}}{{isMany}}',
        save_to_baseline: 'Save to baseline',
        save_to_baseline_success: 'Visual Baseline Collection: {{name}} - v.{{version}} was created.',
        'select-all': 'Select All',
        'a-of-b': '{{a}} of {{b}}',
        'items-selected': 'item(s) selected',
        'item-marked-as': '{{count}} item is marked as {{status}}',
        'items-marked-as': '{{count}} items are marked as {{status}}',
        'incomplete-test-run': 'Incomplete',
        'baseline-collection-group#button-tooltip': 'Rename Baseline Collection',
        'baseline-collection-group#editable-place-holder': 'Enter a name under 256 characters',
        'visual-testing#apply-all#delete-title': 'Delete all ignored zones',
        'visual-testing#apply-all#delete-content': 'Would you like to delete similar ignored zones in other images of the baseline collection?',
        'visual-testing#apply-all#delete-button-title': 'Delete all zones',
        'visual-testing#exceed-quota-warning#standard': 'You have exceeded your monthly limit for checkpoint images. To continue conducting Visual Testing, please wait for the monthly quota refresh or upgrade to Visual Testing Pro. See ',
        'visual-testing#exceed-quota-warning#pro': 'You have exceeded your monthly limit for checkpoint images. To continue conducting Visual Testing, please wait for the monthly quota refresh or upgrade your plan. See ',
        'visual-testing#plan-validation#message': 'This is an exclusive feature of Visual Testing Pro. Consider upgrading your plan to unlock all powerful capabilities. See ',
        upgradeSubscriptions: 'Upgrade subscriptions',
        aboutVSTPro: 'About Visual Testing Professional',
        terminate: 'Terminate',
        terminate_test_run: 'Terminate Test Run',
        notify_successfully_terminated_test_run: 'The execution {{id}} was terminated.',
        apply_all_ignored_zone: 'Apply the zone to all images',
        delete_ignored_zone: 'Delete ignored zone',
        acknowledgement: 'Acknowledgement',
        do_not_show_again: 'Don\'t show this message again',
        acknowledge: 'Acknowledge',
        acknowledge_apply_all_baseline_collection_message: 'The ignored zone might not be applied to all baseline images if the images have different resolutions or exceed ignored zone quota.',
        'jira-integration#enable-xray-title': 'Enable automatic Test Result push to Xray',
        'jira-integration#enable-xray-integration-title': 'Enable Xray integration.',
        'jira-integration#clientId': 'Client ID',
        'jira-integration#clientSecret': 'Client Secret',
        'jira-integration#xray-learmore': 'Learn more about Xray API key',
        'jira-integration#setting-success': 'Your settings have been saved successfully',
        'jira-integration#deactivate-success': 'Your Jira/Xray integration has been deactivated.',
        'jira-integration#connection-failed-title': 'Connection failed!',
        'jira-integration#connection-passed-title': 'Connect Successfully',
        'jira-integration#connection-failed': 'Please check your Jira settings and try again.',
        'jira-integration#test-connection-success': 'Please save your settings before leaving the page.',
        'jira-integration#test-connection-success#one-more-step': 'Now we can go further. One more step.',
        'jira-integration#step1': 'Set up Jira',
        'jira-integration#step2': 'Link Project',
        'jira-integration#step3': 'Map to Xray Issue Type',
        'jira-integration#chooseBoard': 'Scrum Board (Optional)',
        'jira-integration#jiraEntityMapping': 'TestOps-Jira entity mapping (Read-only)',
        'jira-integration-required-title': 'Integrate with Jira to continue',
        'jira-integration-required-btn': 'Integrate with Jira',
        'jira-integration-required-instruction#step1': 'To report defect, you must integrate with Jira project.',
        'jira-integration-required-instruction#step2': 'After integration, you can link existing or create new Jira issues to your current test results.',
        'jira-integration-required-instruction#notTeamManager': 'Please contact your Project Admin to integrate with Jira so that you can Report Defect.',
        'jira-integration-note-xray-issue-type-mapping': 'Select the Xray Issue Type to associate with the corresponding TestOps entities.',
        'jira-integration#xray-issue-type-mapping#test-case': 'Test Case',
        'jira-integration#xray-issue-type-mapping#test-plan': 'Test Plan',
        'jira-integration#xray-issue-type-mapping#test-execution': 'Test Execution',
        'jira-integration#xray-issue-type-mapping#place-holder': 'Select Xray Issue Type',
        'visual-comparison#status@running': '(analyzing...)',
        'failure-reason': 'Failure Reason',
        'system-suggested': 'This failure reason is automatically recommended',
        'visual-comparison#title@analyzing': 'Analyzing',
        'failure-test-result#header-title': 'Failed Test Results',
        'failure-test-result#chart-title': 'By Failure Reason',
        'failure-test-result#chart#tooltip-msg': 'Number of failed test results grouped by each corresponding failure reason.',
        suggested_solution: 'Troubleshooting Guideline',
        'setup-git-repository': 'Set Up Git Script Repository',
        'survey#welcome': 'Welcome to Katalon!',
        'survey#about-survey': 'Can you tell us a bit about yourself? This will help us tailor your experience.',
        'survey#ima': 'I’m a',
        'survey#in': 'In',
        'survey#mygoalisto': 'My goal is to',
        'survey#showmefurther': 'Show me further',
        'survey#hintskip': 'or skip the survey and select an option below to jump straight into your Katalon journey',
        'survey#createandruntest': 'I want to create & run tests',
        'survey#managemyteam': 'I want to manage my team',
        'survey#selectyourrole': 'Select your role',
        'survey#selectindustry': 'Select industry',
        'survey#selectyourgoal': 'Select your goal',
        'survey#title': 'Welcome to Katalon',
        'survey#inputotherrole': 'Input other role',
        'survey#inputotherindustry': 'Input other industry',
        'survey#tooltip#download': 'Download Katalon Studio & continue to TestOps',
        'survey#tooltip#manageteam': 'Visit the Admin Dashboard',
        'git-repository#set-up#title': 'Connect a Git repository to project {{name}}',
        'git-repository#warning#empty-list-repository': 'You currently don\'t have any script repository to schedule/run test',
        'git-repository#set-up#sub-title': 'Use our sample Git repository or connect your own.',
        'git-repository#use-sample#title': 'Use Katalon\'s sample repository',
        'git-repository#use-sample#description': 'Choose sample projects that suit your testing needs.',
        'git-repository#create-new#title': 'Create a new Git repository',
        'git-repository#create-new#description': 'Fill in the credentials to connect your Git repository. You can change these settings later.',
        'sample-git-repository#API': 'API Tests Project',
        'sample-git-repository#BDD': 'BDD Cucumber Tests Project',
        'sample-git-repository#DATA_DRIVEN_TEST': 'Web UI Tests Project (Shopping Cart)',
        'sample-git-repository#WEB_UI': 'Web UI Tests Project (Healthcare)',
        'sample-git-repository#MOBILE_ANDROID': 'Android Mobile Tests Project',
        'sample-git-repository#MOBILE_IOS': 'iOS Mobile Tests Project',
        'sample-git-repository#VISUAL_TESTING': 'Visual Testing Project',
        'learn-more-about-this-sample': 'Learn more about this sample',

        'git-repository#set-up#page-title': 'Default Git Repository Setup',
        'git-repository#set-up-sample#title': 'You can get started with our read-only sample repository.',
        'git-repository#set-up-sample#title-btn': 'Use Sample Git Repository',
        'git-repository#name': 'Script Repository {{name}}',
        'git-repository': 'Git Script Repository',
        'git-repository#form-title': 'Or fill in the information below to connect your Git repository. You can change these settings later.',
        'git-repository#form-title#repository': 'Enter Repository URL',
        'git-repository#form-title#username': 'Enter Username',
        'git-repository#form-title#pat': 'Enter Personal Access Token',
        'git-repository#form-title#password': 'Enter {{label}}',
        'git-repository#form-title#access-key': 'Enter Access Key ID',
        'git-repository#form-title#secret-key': 'Enter Secret Access Key',
        'git-repository#form-title#name': 'Enter Name',
        'git-repository#form-title#description': 'Enter Description',
        'git-repository#form-title#target-directory': 'e.g., sub-folder-1/target-directory-name',
        'github-integration': 'Github Integration',
        'github-integration-connect-success': 'Connection succeeded! You have connected with Github account {{username}} successfully!',
        'custom-fields#title': 'Custom Fields',
        'artificial-intelligence#title': 'Artificial Intelligence',
        'custom-fields#create-new-custom-field': 'Create new custom field',
        'custom-fields#edit-custom-field': 'Edit custom field',
        'custom-fields#display-name': 'Display Name',
        'custom-fields#key': 'Key',
        'custom-fields#value': 'Value',
        'custom-fields#values': 'Values',
        'custom-fields#add-new-value': 'Add new value',
        'custom-fields#clear-selected-items': 'Clear selected items',
        'custom-fields#add-new': 'Add new',
        'custom-fields#placeholder#display-name': 'e.g, Priority, Testing Type',
        'custom-fields#placeholder#key': 'e.g, priority, testing-type',
        'custom-fields#placeholder#value': 'e.g, High/Medium/Low, API/Regression',
        'custom-fields#delete-title': 'Delete custom field',
        'custom-fields#delete-content#first-line': 'Are you sure you want to delete ',
        'custom-fields#delete-content#second-line': 'This will also remove all the custom field values used anywhere in your project.',
        'custom-fields#delete-success': 'The custom field {{displayName}} has been deleted.',
        'custom-fields#create-success': 'Custom field created successfully!',
        'custom-fields#edit-success': 'Custom field updated successfully!',
        'custom-fields#filter-update': 'Update',
        'custom-fields#atg-key-error': 'Can not create this custom field key. Please try again.',
        'return-homepage': 'Return to Homepage',
        'top-exception#header-title': 'Top {{numberOfExceptions}} Exceptions from all Test Results',
        'top-exception#header-title-all-exceptions': 'All Exceptions',
        'top-exception#table-title#index': 'No.',
        'top-exception#table-title#exception-class': 'Exception Class',
        'top-exception#table-title#exceptions': 'Exceptions',
        'top-exception#table-title#number-of-results': 'No. of Test Results',
        'top-exception#table-cell#number-of-results': '{{numberOfTestResults}} test results',
        'view-error': 'View Errors',
        'tag#select-tags': 'Select tags',
        'tag#title': 'Tags',
        'tag#all-tags': 'ALL TAGS',
        'custom-fields-and-tags#title': 'Custom Fields & Tags',
        'welcome-download-ks#welcome-header': 'How do you want to get started?',
        'welcome-download-ks#welcome-subheader': 'You can change your mind later.',
        'welcome-download-ks#platform-title': 'Start on-cloud with the Katalon Platform',
        'welcome-download-ks#platform-information#1': 'Run thousands of parallel tests within just a few hours on our cloud environments.',
        'welcome-download-ks#platform-information#2': 'Manage artifacts & workflows seamlessly with our native integrations.',
        'welcome-download-ks#platform-information#3': 'Use actionable analytics to continuously improve testing workflows and coverage opportunities.',
        'welcome-download-ks#ks-standalone-information#1': 'Start on-premise with Katalon Studio Standalone Edition',
        'welcome-download-ks#ks-standalone-information#2': 'This will download our on-premise test authoring tool with optional cloud integrations.',
        'baseline-collection#properties#default-comparison-method': 'Default Comparison Method',
        'survey#question1#header': 'What’s your primary role?',
        'survey#question2#main-objectives': 'What are your main objectives?',
        'survey#question2#main-objectives#sub-title': '(You can choose more than one)',
        'survey#question2#main-objectives#sub-title-old': '(You can pick more than one)',
        'survey#question1#subheader': 'This helps us recommend features for you.',
        'survey#question2#header': 'What is your team\'s test automation status?',
        'survey#question2#subheader': 'This won\'t limit what you can do in Katalon.',
        'survey#question-option#developer': 'Developer',
        'survey#question-option#manual-tester': 'Manual Tester',
        'survey#question-option#automation-specialist': 'Automation Specialist',
        'survey#question-option#quality-engineer': 'Quality Engineer',
        'survey#question-option#team-lead-manager': 'Team Lead/Manager',
        'survey#question-option#director-vp-cto': 'Director/VP/CTO',
        'survey#question-option#independent-consultant': 'Independent/Consultant',
        'survey#question-option#validate-feature-release': 'Validate new features for release',
        'survey#question-option#increase-automation-test-coverage': 'Increase automation test coverage',
        'survey#question-option#track-manage-project-quality': 'Track & manage project release quality',
        'survey#question-option#define-testing-strategy': 'Define testing strategy',
        'survey#question-option#build-testing-pipelines': 'Build testing pipelines',
        'survey#question-option#other': 'Other',
        'survey#sub-title': 'Let’s get to know each other.',
        'survey#welcome-message': 'Welcome, {{ fullName }}.',
        'way-to-start#header': 'How would you like to start?',
        'way-to-start#subheader': 'We will optimize experience based on your selection.',
        'way-to-start#1': 'Explore our sample project',
        'way-to-start#2': 'Import existing project from Git Repository',
        'way-to-start#3': 'Create new project from scratch',
        'way-to-start#1-description': 'Pre-made test activities, cases, and reports without setup required.',
        'way-to-start#2-description': 'Have existing test repositories and data? Connect it to Platform!',
        'way-to-start#3-description': 'Start automation journey end-to-end with Studio & Platform.',
        back: 'Back',
        continue: 'Continue',
        'visual-testing#pixel-sensitivity': 'Pixel Sensitivity',
        'visual-testing#pixel-sensitivity#strict': 'Strict',
        'visual-testing#pixel-sensitivity#relaxed': 'Relaxed',
        'visual-testing#pixel-sensitivity#tootip-preview': 'When using the Pixel method, pixel sensitivity can be adjusted to be more strict or relaxed to reduce the false positive result.',
        'visual-testing#baseline-collection#tootip-default-method': 'The method that determines the result when comparing a checkpoint image with a baseline image.',
        'visual-testing#baseline-collection#tootip-pixel-sensitivity': 'When using the Pixel method, pixel sensitivity can be adjusted to be more strict or relaxed to reduce the false positive result.',
        'visual-testing#pixel-sensitivity#diffs': 'Diffs: {{diff}}',
        'test-run-daily-options#past-senven-days': 'Past 7 days',
        'test-run-daily-options#past-thirty-days': 'Past 30 days',
        'test-run-daily-options#past-ninety-days': 'Past 90 days',
        'test-run-daily-options#past-twelve-months': 'Past 12 months',
        'test-run-daily-options#custom': 'Custom',
        'test-result#no-video': 'This test result does not contains any videos.',
        'verify-user-email#title': 'Verify your account within 3 days to avoid account being blocked. Check your email for the link. Need a new link?',
        'verify-user-email#resend': 'Resend Verification Email',
        'verify-user-email#success': 'An email has been resent to {{email}}',
        'verify-user-email#resend-email': 'Resend email',
        'verify-user-email#have-trouble': 'Still having trouble?',
        'verify-user-email#resending': 'Resending',
        'verify-user-email#resend-success': 'Verification email sent! Check your email for the new verification link.',
        'verify-user-email#block-account': 'Please verify your account to continue. Click on the verification link sent to your email at ',
        'verify-user-email#block-account-description': 'Can\'t find the email? Check your spam folder or ',
        'verify-user-email#block-account-saml-otp': 'Please verify your account to continue. Check your email at <b>{{userName}}</b> for the verification link.',
        'verify-user-email#block-account-saml-otp-description': 'Can\'t find the email? Check your spam folder or see instructions ',
        'visual-testing#baseline-collection#upload-image': 'Upload Images',
        'visual-testing#baseline-collection#title-upload-baselines-dialog': 'Add image to Baseline Collection',
        'visual-testing#baseline-collection#click-to-upload': 'Click to upload',
        'visual-testing#baseline-collection#drag-drop': 'Drag & Drop',
        'visual-testing#baseline-collection#upload-image-description-one': 'Make sure the baseline image and the checkpoint image have the same name and resolution.',
        'visual-testing#baseline-collection#upload-image-description-two': 'You can only upload PNG or JPG files.',
        'visual-testing#baseline-collection#upload-image-description-three': '(Max {{maxSize}} MB and {{numberImages}} images uploaded at a time)',
        'visual-testing#baseline-collection#upload-image-success': '{{numberImagesUploaded}} new images is added to baseline collection {{baselineCollectionName}}. \r\nBaseline collection is updated to v.{{version}}',
        'visual-testing#baseline-collection#upload-image-fail': 'The image(s) uploading is unsuccessful. Please try again.',
        'visual-testing#baseline-collection#upload-image-tooltip-unsaved': 'Please save all changes before uploading new image(s).',
        'visual-testing#baseline-collection#upload-image-tooltip-vst-standard': 'Please subscribe Visual Testing Professional to start using the feature.',
        'visual-testing#baseline-collection#invalid-size': 'File is larger than {{size}} MB.',
        'visual-testing#baseline-collection#duplicated-name': 'File exists in baseline collection.',
        'visual-testing#baseline-collection#number-images-error': '{{numberOfImagesError}} unqualified image(s) not available to upload.',
        'visual-testing#baseline-collection#upload-image-banner-warning': 'Please remove at least {{numberOfImages}} image(s) due to exceeding maximum quota ({{quota}}).',
        'xray#test-plan#push': 'Push to Xray',
        'xray#test-plan': 'Xray Test Plan',
        'xray#test-plan#placehoder': 'e.g, TEST-123: Big release test plan',
        'xray#import-report-type#push-manually': 'Manual push only',
        'xray#import-report-type#push-on-all-runs': 'Push on all runs',
        'xray#import-report-type#push-on-passing-runs': 'Push on passing runs only',
        'xray-test-execution#linked-title': 'Linked Xray Test Execution',
        'visual-testing#baseline-collection#create-baseline-collection-btn': '+ Baseline Collection',
        'visual-testing#baseline-collection#create-baseline-collection-title': 'Create a new Baseline Collection',
        'visual-testing#baseline-collection#baseline-collection-name': 'Baseline Collection Name',
        'visual-testing#baseline-collection#upload-image-section-title': 'Upload Baseline Image (s)',
        'baseline-collection#create': 'Create',
        'baseline-collection#place-holder-name': 'Enter a name',
        'visual-testing#baseline-collection#create-baseline-collection-success': '{{baselineCollectionName}} (ID: {{order}}) is created.',
        'warning-filter-dialog#title': 'May lead to thumb twiddling',
        'warning-filter-dialog#first-line': "You've created a query that will search for test runs made ",
        'warning-filter-dialog#over-mt-90-days': 'over more than 90 days',
        'warning-filter-dialog#second-line': 'A lot has happened during that time, so this might take a while. Also, data visualization will not be displayed for this huge query.',
        'test-run-daily-report#empty-data': 'Unable to display chart visualization. Please consider using a time range shorter than 90 days',
        ok: 'OK',
        optional: '(optional)',
        'jira-webhook#title': 'Webhook',
        'jira-webhook#creating#description': 'Webhook is used to synchronise the life cycle of a defect created on Katalon side with Jira issue linked to this defect.',
        'jira-webhook#creating#learn-more': 'Learn more about using Webhook with Katalon.',
        'jira-webhook#creating#creating-btn': 'Create Webhook',
        'jira-webhook#naming-and-copying-dialog#title': 'Create Webhook for Jira Integration',
        'jira-webhook#naming-dialog#description': 'Choose a name that is short, memorable, and easy for you to remember.',
        'jira-webhook#naming-dialog#input-label': 'Name',
        'jira-webhook#naming-dialog#input-placeholder': 'Input webhook name',
        'jira-webhook#copying-dialog#description': 'Make sure you copy your new webhook URL. You won’t be able to see this URL again.',
        'jira-webhook#warning-dialog#title': 'Warning',
        'jira-webhook#delete-webhook#title': 'Delete Webhook',
        'jira-webhook#warning-dialog#description': "Your current webhook URL will be disabled when you're creating the new one. Do you want to continue?",
        'jira-webhook#delete-dialog#description': 'Are you sure you want to delete this active webhook URL? The URL will be deleted permanently.',
        'jira-webhook#delete-dialog#toast-success': 'Delete active Webhook successfully',
        'jira-webhook#active-title': 'Active Webhook',
        'jira-webhook#created-at': 'Created at',
        'jira-settings#change-workspace-dialog#title': 'Switching JIRA Workspace',
        'jira-settings#change-workspace-dialog#confirm-btn': 'Yes, switch workspace',
        'jira-settings#change-workspace-dialog#description': 'You are about to switch to a new JIRA workspace. As a result: ',
        'jira-settings#change-workspace-dialog#description#first-line': 'All linked JIRA tickets from old workspace will be hidden.',
        'jira-settings#change-workspace-dialog#description#second-line': 'The webhook for your old workspace will also be removed. You will need to setup webhook for your new workspace to receive auto-updates.',
        'jira-settings#change-workspace-dialog#description#third-line': 'Do you want to proceed?',
        'show-less': 'Show less',
        'show-more': 'Show more',
        none: 'None',
        'jira-filter#assignee-label': 'Assignee',
        'jira-filter#priority-label': 'Priority',
        'jira-filter#assignee-place-holder': 'Filter assignee',
        'test-case#maintainer#placeholder-select': 'Choose user from the list to assign to the test case.',
        'defect-chart-summary#type-created': 'Created',
        'defect-chart-summary#type-resolved': 'Resolved',
        'defect-chart-summary#type-open': 'Open',
        'defect-chart-summary#tooltip-content-created': 'Total created defects within the chosen time frame',
        'defect-chart-summary#tooltip-content-resolved': 'Total resolved defects within the chosen time frame',
        'defect-chart-summary#tooltip-content-open': 'Number of opened defects at the end the chosen time frame',
        applicationUnderTest: 'Application Under Test',
        userJourneys: 'User Journeys',
        selected: 'Selected',
        publish: 'Publish',
        'publish-test-case#title': 'Publish Test Case',
        repository: 'Repository',
        'select-test-case-tree#placeholder': 'Select Test Cases to add to this Test Suite',
        'select-test-suite-tree#placeholder': 'Select Test Suite',
        'select-location': 'Select Location',
        'publish-test-case#test-case-name': 'Test Case Name',
        'publish-test-suite#test-suite-name': 'Test Suite Name',
        'commit-message': 'Commit Message',
        'publish-test-case#test-case-name-existing#title': 'A test case with the same name already exists in this location. You can:',
        'publish-test-case#test-case-name-existing#option1': 'Change the name or location',
        'publish-test-case#test-case-name-existing#option2': 'Continue to publish & overwrite the existing test case',
        'publish-test-case#successfully': 'Your <b>{{testCaseName}}</b> has been published to <b>{{testCasePath}}</b> successfully.',
        'publish-test-case#successfully-edit': 'Your <b>{{testCaseName}}</b> has been overwritten to <b>{{testCasePath}}</b> successfully.',
        'publish-test-suite#successfully-edit': 'Your <b>{{testSuiteName}}</b> has been published to <b>{{testSuitePath}}</b> successfully.',
        'publish-test-suite#successfully-save': 'Your <b>{{testSuiteName}}</b> has been saved to <b>{{testSuitePath}}</b> successfully.',
        'publish-test-suite#successfully': 'Your <b>{{testSuiteName}}</b> has been created and published to <b>{{testSuitePath}}</b> successfully.',
        'create-test-case#failed#title': 'Failed to create test case',
        'create-test-case#failed#message': 'Cannot create test case. Please try again.',
        'moved-test-case#successfully#title': 'Test case moved',
        'moved-test-case#successfully#message': 'Test case <b>{{testCaseName}}</b> moved to <b>{{testCasePath}}</b>.',
        'moved-list-test-case#successfully#message': '{{numberOfTestCases}} Test cases moved to <b>{{newPath}}</b>.',
        'moved-list-test-suite#successfully#message': '{{numberOfTestSuites}} Test suites moved to <b>{{newPath}}</b>.',
        'moved-test-case#failed#title': 'Move failed',
        'moved-list-test-case#failed#message': '{{numberOfTestCases}} selected Test cases could not be moved. Please try again.',
        'moved-list-test-suite#failed#message': '{{numberOfTestSuites}} selected Test suites could not be moved. Please try again.',
        'moved-test-case#failed#message': 'Test case <b>{{testCaseName}}</b> could not be moved. Please try again.',
        'delete-test-case#failed-description': 'Test case <b>{{testCaseName}}</b> could not be deleted. Please try again.',
        'delete-test-case#failed-title': 'Delete failed',
        'deleted-test-case#successfully#message': 'Test case <b>{{testCaseName}}</b> deleted.',
        'deleted-test-case-old#successfully#title': 'Test case deleted',
        'deleted-test-cases#successfully#message': '{{testCaseNumber}} Test cases deleted.',
        'deleted-test-case#successfully#title': 'Delete successfully',
        'moved-test-suite#successfully#title': 'Test suite moved',
        'moved-test-suite#successfully#message': 'Test suite <b>{{testSuiteName}}</b> moved to <b>{{testSuitePath}}</b>.',
        'moved-test-suite#failed#title': 'Move failed',
        'moved-test-suite#failed#message': 'Test suite <b>{{testSuiteName}}</b> could not be moved. Please try again.',
        'renamed-test-case#failed#title': 'Rename failed',
        'renamed-test-case#failed#message': 'Test case <b>{{testCaseName}}</b> could not be renamed. Please try again.',
        'renamed-test-suite#failed#title': 'Rename failed',
        'renamed-test-suite#failed#message': 'Test suite <b>{{testSuiteName}}</b> could not be renamed. Please try again.',
        'add-successfully': 'Add successfully',
        'add-tc-to-ts-successfully': 'Your <b>{{testCaseName}}</b> has been added to <b>{{testSuiteName}}</b>',
        'add-to-ts-successfully': 'Test case <b>{{testCaseName}}</b> added to <b>{{testSuiteName}}</b>.',
        'enter-name': 'Enter a name',
        'invalid-folder-name': "Invalid name! A folder name must start with English letters or numbers, mustn't end with a dot (.), and can mix up with space or any of the following characters: ( ) . , _ - ",
        'invalid-folder-name#specific-name': 'Invalid name! "TestOps" folder under "test-suites/" is reserved for auto-generated test suites of Test Case Run.',
        'tree-path-placeholder': 'Selected location will appear here...',
        'publish-test-case#not-collaborator': 'You do not have the permission to push to this repository. Please use personal Git credentials with proper permissions or select another repo.',
        'commit-placeholder': 'Input commit message',
        'add-new-folder-title': 'Add new folder',
        'published-location': 'Set Up Location',
        'test-case#duplicated': 'A test case with the same name already exists in this location.',
        'test-suite#duplicated': 'A test suite with the same name already exists in this location.',
        'test-case#moving#info': 'Moving a published test case will merge the current draft version into it.',
        'add-test-case': 'Add Test Case',
        'publish-test-suite#dialog-create-title': 'Create Cloud Studio Test Suite',
        'publish-test-suite#title': 'Publish Test Suite',
        'publish-test-suite#test-suite-name-existing#title': 'A test suite with the same name already exists in this location. You can:',
        'publish-test-suite#test-suite-name-existing#option1': 'Change the name or location',
        'publish-test-suite#test-suite-name-existing#option2': 'Continue to publish & overwrite the existing test suite',
        'untitled-folder': 'Untitled folder',
        number_of_defects: 'Number of Defects',
        'publish-test-case#default-commit-message': 'Katalon: Update test case {{testCaseName}} in {{-testCasePath}}',
        'publish-test-suite#default-commit-message': 'Katalon: Update test suite {{testCaseName}} in {{-testCasePath}}',
        location: 'Location',
        current_location: 'Current Location',
        'defect-report': 'Defect Report',
        'empty-state#sub-text': 'Report is currently empty. Things you can do to view',
        'defect-empty-state#step-one#title': 'Activate Jira integration',
        'defect-empty-state#step-one#description': 'Activate and set up Jira integration with Katalon Platform in order to analyze Defects.',
        'defect-empty-state#step-two#title': 'Link Jira test results',
        'defect-empty-state#step-two#description': 'Link your Jira test results to provide meaningful data for Defect Report.',
        'defect-empty-state#media#title': 'Project Platform General - Defects - Katalon TestOps',
        'change-personal-git-credential': 'Update Git Credentials',
        'connect-new-git-repo': 'Connect New Repository',
        'cloud-studio': 'Cloud Studio',
        'katalon-studio': 'Katalon Studio',
        'katalon-platform': 'Katalon Platform',
        undo: 'UNDO',
        'first-project-setup': 'First Project Setup',
        'get-started': 'Get Started',
        'latest-run': 'Latest Run',
        'manual-test-case': 'Manual Test Case',
        'onboarding-checklist#header#title': 'Getting started!',
        'onboarding-checklist#header#description': 'We\'ll guide you on how to use Katalon Studio to create automated tests, ' +
            'and utilize Katalon Platform to manage and sync results for easy collaboration ' +
            'and streamlined test activities. Let\'s begin!',

        'organization-empty-state#admin#step-one#title': 'Create new project in Admin site',
        'organization-empty-state#admin#step-one#content': 'Navigate to Project Management to create and assign a team to your new project.',
        'organization-empty-state#admin#step-two#title': 'Go back to Katalon Platform to get started',
        'organization-empty-state#admin#step-two#content': 'After successfully creating a new project, navigate to your project to start experiencing the power of centralized testing with Katalon Platform.',
        'organization-empty-state#member#content': 'You have no permission to create a new project in this organization. Please contact Organization Admin to create a new one or you can visit your own organization to get started.',
        'organization-empty-state#title': 'Currently, there are no projects in this organization.',
        create_new_project: 'Create New Project',
        'testops-onboarding-step1-title': 'Download & login on KS',
        'testops-onboarding-step1-desc': 'Setup within a few minutes to easily write automated tests with our low-code IDE.',
        'testops-onboarding-step2-title': 'Sync data from Studio Project to TestOps',
        'testops-onboarding-step2-desc': 'Unlock the full potential of the Katalon Platform by connecting your Studio project to the TestOps platform.',
        'testops-onboarding-step3-title': 'Analyze test result',
        'testops-onboarding-step3-desc': 'Explore the power of the TestOps Platform for analyzing and debugging test failures.',
        'testops-onboarding-step4-title': 'Setup Script Repository',
        'testops-onboarding-step4-desc': 'Connect to a Git repository that stores your Studio scripts to allow create suites and run remote tests on TestOps.',
        'testops-onboarding-step5-title': 'Create Test Suite on TestOps',
        'testops-onboarding-step5-desc': 'TestOps can quickly create a test suite, saving time compared to creating one and adding it to the Script Repo in Studio.',
        'testops-onboarding-step6-title': 'Execute your test remotely using TestOps',
        'testops-onboarding-step6-desc': 'Execute tests with cloud-based environment, no manual setup.',
        'testops-onboarding-step7-title': 'Invite your team members',
        'testops-onboarding-step7-desc': 'Invite team members to your project to ensure seamless collaboration and centralized quality management.',
        'testops-onboarding-step8-title': 'Integrate with a JIRA Project',
        'testops-onboarding-step8-desc': 'Enable requirements and defects to be linked to test cases, populating releases from JIRA for quality visibility.',
        'testops-onboarding-step9-title': 'Upload Test Results manually',
        'testops-onboarding-step9-desc': 'Uploading test results from other sources to centralize testing data and streamlines the testing process.',
        'testops-onboarding-step10-title': 'Setup Local Agent',
        'testops-onboarding-step10-desc': 'Remotely run tests on TestOps from your computer or docker image by setting up Agent.',
        'testops-onboarding-step11-title': 'Create your own project',
        'testops-onboarding-step11-desc': 'Create your real project and take your testing process to the next level with Katalon Platform!',
        'ks-onboarding-step1-title': 'Create your first project',
        'ks-onboarding-step1-desc': 'Create and open your first project to start your automated testing journey.',
        'ks-onboarding-step2-title': 'Write your first test case',
        'ks-onboarding-step2-desc': 'Create your first automated test case to utilize it in multiple scenarios.',
        'ks-onboarding-step3-title': 'Plan your tests with a Test Suite',
        'ks-onboarding-step3-desc': 'Save time and effort by grouping related test cases together in a test suite.',
        'ks-onboarding-step4-title': 'Analyze your test activities with Cloud Platform',
        'ks-onboarding-step4-desc': 'Track your test executions and results overtime, for a better quality management.',
        'ks-onboarding-step5-title': 'Try cross-browser cloud testing',
        'ks-onboarding-step5-desc': 'Run with environments of your choice without manual setup',
        'ks-onboarding-step6-title': 'Execute test via CI/CD pipeline with Runtime Engine',
        'ks-onboarding-step6-desc': 'Already have a CI/CD pipeline? Use Runtime Engine to execute your tests.',
        'ks-onboarding#tooltip': 'All tours here are synchronized and marked as completed at Katalon Studio',
        'analyze-result': 'Analyze Result',
        'connect-git': 'Connect Git',
        'create-test-suite': 'Create Test Suite',
        'execute-test': 'Execute Test',
        'invite-members': 'Invite Members',
        'integrate-jira': 'Integrate JIRA',
        'upload-results': 'Upload Results',
        'setup-agent': 'Setup Agent',
        collapse: 'Collapse',
        expand: 'Expand',
        dismiss: 'Dismiss',
        'not-support-actions': 'We do not yet support quick actions for this object.',
        'block-actions-for-instant-run': 'Test Suite auto-generated from Test Case Run cannot be modified.',
        move: 'Move',
        'move-to': 'Move to',
        'move-number-items-to': 'Move {{numberItems}} items to',
        'onboarding-dismiss-dialog#title': 'Dismiss checklist',
        'onboarding-dismiss-dialog#description': "You're about to dismiss the getting started checklist. After dismiss, it will no longer appear on your Project Dashboard and can only be accessed again through Resource Center.\n\nDo you want to proceed?",
        'onboarding-dismiss-dialog#dismiss-btn': 'Yes, Dismiss',
        'prerequisites-text': 'You should complete the following action(s) beforehand:',
        'publish-test-project-failed#title': 'Failed to publish!',
        'publish-test-project-failed#desription': 'Unable to publish to your repository. Please check repository settings and try again.',
        git: 'Git',
        cloudStorage: 'Cloud Storage',
        uploadedRepository: 'Uploaded Repository',
        ai: 'AI',
        'ai-suggestions': "Use one of these options to quickly get a snapshot of your system's status and receive insights generated by AI.",
        'ai-happening-now': 'Happening Now',
        'test-progress': 'Test Progress',
        'passed-tests': 'Passed Tests',
        'failed-tests': 'Failed Tests',
        'testing-progress': 'Testing Progress',
        'testing-progress-tooltip': 'This section displays your test execution progress based on passed/failed statuses and recent runs linked to your release.',
        'open-defects': 'Open Defects',
        'open-defects-tooltip': 'This section displayed the list of defects linked to the release, via test results.',
        'execution-by-test-environment': 'Execution By Profile',
        'execution-by-test-environment-tooltip': 'This section displays all profiles tested in the release along with their execution status.',
        'execution-by-platforms': 'Execution By Platform',
        'execution-by-platforms-tooltip': 'This section displays all platforms tested in the release along with the execution status.',
        'impacted-locations': 'Impacted Areas',
        'impacted-locations-tooltip': 'This section displays the testing progress and failure rate of different modules in your release, grouped by test folders.',
        'folder-locations': 'Folder Locations',
        'folder-location': 'Folder Location',
        'issue-created': 'Issue Created',
        'unlink-issue': 'Unlink Issue',
        'jira-integration-add-on-old': 'Please install the Jira Integration add-on in your browser to use this feature. ',
        'jira-integration-add-on-new': 'For better result linking experience, try Katalon Integration Plugin for Chrome. ',
        'jira-navigate': 'Navigate to Jira',
        'ai-release-readiness-question': 'How’s the upcoming release going?',
        'ai-release-readiness-question-title': 'The system automatically choose the most recent upcoming release.',
        'ai-common-failures-question': 'Analyze common errors observed in the project',
        'ai-test-stability-question': 'Analyze the stability of tests in this project last 7 days',
        'ai-release-readiness': 'Release Readiness',
        'ai-common-failures': 'Analyze Test Results',
        'ai-test-stability': 'Quality Monitoring',
        'new-failures': 'New Failures',
        'new-failures-tooltip': 'New Failures count indicates the number of tests that failed with any error for the first time in their last 5 runs last 7 days.',
        'new-defects': 'New Defects',
        'new-defects-tooltip': 'Number of defects created and linked to test results in last 7 days.',
        'always-failing': 'Always Failing',
        'always-failing-tooltip': 'The number of tests that have all failed in their last 5 runs over the last 7 days.',
        'last-seven-days': 'Last 7 Days',
        'test-health-summary': 'Test Health Summary',
        'flaky-tests': 'Flaky Tests',
        'flaky-tests-tooltip': 'Number of tests whose statuses have flipped from passed to failed (or vice versa) in the last 10 runs over the last 7 days.',
        'new-failure': 'New Failure',
        'new-failure-tooltip': 'The number of tests that failed with any error for the first time in their last 5 runs last 7 days.',
        'top-5-failures': 'Top Failures',
        'top-5-failures-tooltip': 'This section displays a summary of failures from the last 7 days and the top 5 test cases with the highest failure rates.',
        'failure-tests': 'Failure Tests',
        'avg-failure-rate': 'Avg. Failure Rate',
        'failure-by-locations': 'Failure By Locations',
        'failure-by-locations-tooltip': 'This section represents the failure rate of different modules in your systems, grouped by test folders.',
        'top-5-slowest-tests': 'Slowest Tests',
        'top-flaky-tests': 'Top Flaky Tests',
        'top-flaky-tests-tooltip': 'This section represents the flakiness distribution of your project based on test results executed last 7 days, along with top flaky tests.',
        'high-severity': 'High Severity',
        'high-severity-tooltip': 'Number of flaky tests with flaky rate in range 51-100%.',
        'medium-severity': 'Medium Severity',
        'medium-severity-tooltip': 'Number of flaky tests with flaky rate in range 11-50%.',
        'low-severity': 'Low Severity',
        'low-severity-tooltip': 'Number of flaky tests with flaky rate in range 1-10%.',
        'failed-run': 'Failed Runs',
        'failed-results': 'Failed Results',
        'failure-rate': 'Failure Rate',
        'total-runs': 'Total Runs',
        'flaky-rate': 'Flaky Rate',
        'common-errors-in-past-7-days': 'Top Common Errors Last 7 Days',
        'total-impacted-tests': 'Total failed tests',
        'total-impacted-tests-tooltip': 'The number of executed tests that encountered errors last 7 days.',
        'total-error-count': 'Total error counts',
        'total-error-count-tooltip': 'The number of error occurrences over the last 7 days.',
        'most-common-errors': 'Top 10 Common Errors',
        'impacted-tests': 'Impacted Tests',
        'error-count': 'Error Count',
        'generate-ai-insights': 'Generate AI Insights',
        'error-message-copied': 'Error message copied.',
        'ai-insights-copied': 'AI Insights copied.',
        'ai-insights': 'AI Insights',
        'ai-no-permission-member#title': 'AI features are not enabled for your organization.',
        'ai-no-permission-member#body': 'Please contact your Organization Owner for further information.',
        'ai-no-permission-admin#title': 'AI features are currently disabled for your organization.',
        'ai-no-permission-admin#body': 'You can enable them via Admin > Account Settings',
        'ai-go-to-configuration': 'Go To Configuration',
        'last-seen': 'Last seen',
        'ai-inaccurate-misleading': 'Al responses can be inaccurate or misleading.',
        severity: 'Severity',
        failures: 'Failures',
        rename: 'Rename',
        'rename-test-case-dialog#title': 'Rename',
        'rename-test-case-dialog#test-case-name': 'Test case name',
        'rename-test-case-dialog#cancel-button': 'Cancel',
        'rename-test-case-dialog#rename-button': 'Rename',
        'rename-test-case-dialog#info-message': 'Renaming a published test case will merge the current draft version into it.',
        'rename-test-case-dialog#success-message': 'Test case renamed to <b>{{testCaseName}}</b>.',
        testCaseRenamed: 'Test case renamed',
        'rename-test-suite-dialog#success-message': 'Test suite renamed to <b>{{testSuiteName}}</b>.',
        'rename-test-suite-dialog#test-suite-name': 'Test suite name',
        'test-suite-renamed': 'Test suite renamed',
        'duplicate-test-case-old#success-title': 'Test case duplicated',
        'duplicate-test-case#success-title': 'Duplicate successfully',
        'duplicate-test-case#success-description': 'Test case <b>{{testCaseName}}</b> duplicated.',
        'duplicate-test-cases#success-description': '{{testCaseNumber}} selected test cases duplicated.',
        'duplicate-test-case-old#failed-title': 'Duplication failed',
        'duplicate-test-case-old#failed-description': 'Test case <b>{{testCaseName}}</b> could not be duplicated. Please try again.',
        'duplicate-test-case#failed-title': 'Duplicate failed',
        'duplicate-test-case#failed-description': 'Test case <b>{{testCaseName}}</b> failed to duplicate.<br> Please try again.',
        'duplicate-test-cases#failed-description': '{{testCaseNumber}} selected test cases  failed to duplicate.<br> Please try again.',
        'duplicate-test-suite#success-title-old': 'Test suite duplicated',
        'duplicate-test-suite#success-title': 'Duplicate successfully',
        'duplicate-test-suite#success-description': 'Test suite <b>{{testSuiteName}}</b> duplicated.',
        'duplicate-test-suites#success-description': '{{testSuiteNumber}} selected test suites duplicated.',
        'duplicate-test-suite#failed-title-old': 'Duplication failed',
        'duplicate-test-suite#failed-description-old': 'Test suite <b>{{testSuiteName}}</b> could not be duplicated. Please try again.',
        'duplicate-test-suite#failed-title': 'Duplicate failed',
        'duplicate-test-suite#failed-description': 'Test suite <b>{{testSuiteName}}</b> failed to duplicate.<br> Please try again.',
        'duplicate-test-suites#failed-description': '{{testSuiteNumber}} selected test suites failed to duplicate.<br> Please try again.',
        'duplicate-test-suite#duplicate-deleted-test-suite-error-description': 'Test suite <b>{{testSuiteName}}</b> has been deleted since you last took action.<br>Please reload the page and try again.',
        'duplicate-test-suites#duplicate-deleted-test-suite-error-description': '{{testSuiteNumber}} test suites have been deleted since you last took action.<br>Please reload the page and try again.',
        'delete-test-suite#success-title': 'Test suite deleted',
        'delete#success-title': 'Delete successfully',
        'delete-test-suite#success-description': 'Test suite <b>{{testSuiteName}}</b> deleted.',
        'delete-test-suites#success-description': '{{testSuiteNumber}} Test suites deleted.',
        'delete-test-suite#failed-title': 'Delete failed',
        'delete-test-suite#failed-description': 'Test suite <b>{{testSuiteName}}</b> could not be deleted. Please try again.',
        'delete-test-suites#failed-description': '{{testSuiteNumber}} selected Test suites could not be deleted. Please try again.',
        'gpt-service': 'GPT service',
        'gpt-service#description': 'Used for Virtual Data Analyst.',
        'gpt-service#dialog#header': 'Using OpenAI API keys',
        'gpt-service#dialog#1st-part': 'Katalon Platform provide a free quotation for users to try our AI services. But it also has the quota limitation. This is why we encourage you using your own OpenAI API keys for more quotation.',
        'gpt-service#dialog#2nd-part': 'Please follow 2 simple steps',
        'gpt-service#dialog#step-1': 'Step 1: Log in to your OpenAI account to get the OpenAI API key.',
        'gpt-service#dialog#step-2#1': 'Step 2: Log in to Katalon project, navigate to ',
        'gpt-service#dialog#step-2#2': 'Settings/Artificial Intelligence',
        'gpt-service#dialog#step-2#3': ' and add your key to the service you want.',
        'gpt-service#dialog#3rd-part': 'This action is only for Owner and Admin role. Please contact them if you are a member.',
        'gpt-service#key#placeholder': 'Service API key',
        'gpt-service#delete#dialog-header': 'Delete service API key',
        'gpt-service#delete#dialog-content': 'The delete action cannot be undone. After deleting the API key, you cannot use the GPT service.',
        deleted: 'Deleted!',
        'more-actions': 'More actions',
        'gpt-service#delete#toast-success': 'Your key has been deleted.',
        'service-ad': 'More features will be added in the future. Stay tuned!',
        'gpt-service#save': 'Saved!',
        'gpt-service#notification#save-successfully': 'Your key has been saved.',
        'gpt-service#add-key': 'Add Key',
        'git-script-repository#GITHUB#repository#placeholder': 'e.g., https://github.com/username/repository-name.git',
        'git-script-repository#GITHUB#username#placeholder': 'e.g., username',
        'git-script-repository#GITHUB#password#placeholder': 'e.g., ········',
        'git-script-repository#GITLAB#repository#placeholder': 'e.g., https://gitlab.com/username/repository-name.git',
        'git-script-repository#GITLAB#username#placeholder': 'e.g., username',
        'git-script-repository#GITLAB#password#placeholder': 'e.g., ········',
        'git-script-repository#BITBUCKET#repository#placeholder': 'e.g., https://username@bitbucket.org/username/repository-name.git',
        'git-script-repository#BITBUCKET#username#placeholder': 'e.g., username',
        'git-script-repository#BITBUCKET#password#placeholder': 'e.g., ········',
        'git-script-repository#AZURE#repository#placeholder': 'e.g., https://dev.azure.com/organization-name/project-name/_git/repository-name',
        'git-script-repository#AZURE#username#placeholder': 'e.g., username',
        'git-script-repository#AZURE#password#placeholder': 'e.g., ········',
        'git-script-repository#AWS#repository#placeholder': 'e.g., https://git-codecommit.your-region.amazonaws.com/v1/repos/repository-name',
        'git-script-repository#AWS#username#placeholder': 'e.g., username',
        'git-script-repository#AWS#password#placeholder': 'e.g., ········',
        'git-script-repository#AWS#accessKeyId#placeholder': 'e.g., XXXXXXXXXXXX',
        'git-script-repository#AWS#secretAccessKey#placeholder': 'e.g., ········',
        'git-script-repository#OTHERS#repository#placeholder': 'e.g., https://example.com/example.git',
        'git-script-repository#OTHERS#username#placeholder': 'e.g., username',
        'git-script-repository#OTHERS#password#placeholder': 'e.g., ········',
        'test-management-actions#RUN': 'Run',
        'test-management-actions#RENAME': 'Rename',
        'test-management-actions#EDIT': 'Edit',
        'test-management-actions#EDIT#test-case': 'Edit Test Steps',
        'test-management-actions#EDIT#test-suite': 'Edit Test Case List',
        'test-management-actions#DUPLICATE': 'Duplicate',
        'test-management-actions#MOVE': 'Move',
        'test-management-actions#DELETE': 'Delete',
        'test-management-actions#ADD_TO_TEST_SUITE': 'Add to Test Suite',
        here: 'here',
        general: 'General',
        'no-release-title': 'There’s no active upcoming release',
        'no-release-desc': 'Start creating your release or populating from JIRA, then link your test using test run.',
        'go-to-releases': 'Go to Releases',
        'no-test-stability-title': 'There’s no test activities in the last 7 days.',
        'no-test-stability-desc': 'Start execute your tests to view testing trend',
        'go-to-executions': 'Go to Executions',
        'test-case-execution': 'Test Case Execution',
        'top-5-failed-test-cases': 'Top 5 Failed Test Cases',
        'top-5-slowest-test-cases': 'Top 5 Slowest Test Cases',
        all: 'All',
        'integration#codeless-automation-tool': 'Codeless Automation Tool',
        'integration#alm-test-management': 'ALM & Test Management',
        'integration#ci-cd-pineline': 'CI/CD Pipeline',
        'integration#collaboration': 'Collaboration',
        'integration#mobile-device-testing': 'Mobile Device Testing',
        'integration#testing-framework': 'Testing Framework',
        'integration#restrict-access-title': 'Only Team Admin can configure this item.',
        'integration#search-input#place-holder': 'Search by name or category (e.g. collaboration, ALM)',
        'integration#search-results#no-data': 'No results match your search \'{{-searchValue}}\'',
        'delete-test-suite': 'Delete Test Suite',
        'delete-test-suites': 'Delete {{numberOfTestSuites}} Test Suites',
        'delete-test-suite#content': 'This action cannot be undone. Are you sure you want to delete the test suite',
        'delete-test-suites#content': 'This action cannot be undone. Are you sure you want to delete {{numberOfTestSuites}} selected test suites?',
        'delete-test-case-old': 'Delete Test Case',
        'delete-test-case-old#content1': 'This action will permanently delete the selected test case and all of its draft versions.',
        'delete-test-case-old#content2': 'Are you sure you want to delete the test case',
        'delete-test-case': 'Delete Test Case',
        'delete-test-case#content': 'This action cannot be undone. Are you sure you want to delete the test case ',
        'delete-test-cases': 'Delete Test Cases',
        'delete-test-cases#content': 'This action cannot be undone. Are you sure you want to delete {{testCaseNumber}} selected test cases?',
        team: 'Team',
        addToTestSuite: 'Add to Test Suite',
        selectedTestCases: 'selected test cases',
        'cloud-studio#guide-header': 'Record to create automated test case',
        'cloud-studio#guide-body': 'Select your webapp & record your web interactions into test steps.',
        'cloud-studio#guide-btn': 'Guide me',
        'current-project': 'Current Project',
        'current-board': 'Current Board',
        'refresh-button#action': ' This action will:',
        'refresh-button#action-1': 'Fetch all Jira tickets that have been linked to this TestOps project.',
        'refresh-button#action-2': 'Populate all Jira project fields with the corresponding TestOps project fields.',
        'configure-test-run': 'Configure Test Run',
        'run-test': 'Run Test',
        'configure-test-run#info': 'A Test Suite and a Schedule under the same name as this Test Case will be automatically generated.',
        'test-environment': 'Test Environment',
        'selete-test-environment': 'Select Test Environment...',
        done: 'Done',
        'schedule-cannot-modified': 'Schedule auto-generated from Test Case Run cannot be modified.',
        'test-suite-cannot-modified': 'Test Suite auto-generated from Test Case Run cannot be modified.',
        'instant-test-run#execution-success': 'Test case <b>{{testCaseName}}</b> has been executed.',
        'view-run-progress': 'View Run Progress',
        'instant-test-run#execute-failed': 'Can\'t execute <b>{{testCaseName}}</b>.</br> Please try again.',
        'refresh-script-repository': 'Refresh Script Repository',
        'report-defect': 'Report Defect',
        'link-defect': 'Link Defect',
        'create-new-issue': 'Create new issue',
        'link-existing-issue': 'Link existing issue',
        'cannot-create-unsupported-field-jira': 'Cannot create with this issue type because it has unsupported field(s).',
        'learn-jira-field': 'Learn more about Jira field types.',
        suggestion: 'Suggestion',
        'go-to-jira-to-create': 'Go to your Jira site to create issue.',
        'go-to-jira': 'Go to Jira',
        'then-go-back-to-link-test-result': 'Then go back to link that issue to this test result.',
        'jira-issue': 'Jira Issue',
        'you-can-change-jira': 'You can change your Jira Project at',
        'current-jira-project': 'Current Jira Project',
        'prefill-description-jira#test-result-link': '- Katalon Test Result Link: ',
        'prefill-description-jira#error-message': '\n- Error Message: ',
        'prefill-description-jira#expected-result-and-root-cause': '\n- Expected result: <Fill in here>\n- Root cause: <Fill in here>\n',
        'discard-issue-dialog#title': 'Your changes won’t be saved',
        'discard-issue-dialog#content': 'We won’t be able to save or update your Jira issue if you leave the page.',
        'discard-automation-rule-dialog#content': 'We won’t be able to save your automation rule if you leave the page.',
        'discard-and-back': 'Discard and Back',
        'continue-editing': 'Continue Editing',
        'discard-issue': 'Discard Issue',
        'go-to-issue': 'Go to issue',
        'issue-type': 'Issue Type',
        'bulk-operations#add-success': '{{testCaseQuantity}} test cases added to <b>{{testSuiteName}}</b>.',
        'select-issue-display-fields': 'Select an issue to display fields here.',
        'select-issue-link-defect': 'Select an issue to link defect.',
        'create-external-issue#error-message': 'Cannot link Jira issue to test result <b>{{testResultId}}</b>. Please try again.',
        'link-external-issue#success-message': 'Jira issue <b>{{issueId}}</b> has been linked to test result <b>{{testResultId}}</b> successfully.',
        'link-external-issue#error-message': 'Cannot link Jira issue <b>{{issueId}}</b> to test result <b>{{testResultId}}</b>. Please try again.',
        'no-option': 'No option',
        'automation-rule': 'Automation Rule',
        'create-automation-rule': 'Create Automation Rule',
        'create-automation-rule#success-message': 'Automation rule <b>{{ruleName}}</b> has been created successfully.',
        'create-automation-rule#error-message': 'Cannot create automation rule for the defect <b>{{issueId}}</b>.',
        'edit-automation-rule': 'Edit Automation Rule',
        'validate-automation-rule#null-pattern': 'Pattern of Error message or Stack trace is required.',
        'error-details': 'Error details',
        'error-message-details': 'Error message details',
        'stack-trace-details': 'Stack trace details',
        'error-message': 'Error message',
        'stack-trace': 'Stack trace',
        'create-rule': 'Create Rule',
        'rule-name': 'Rule name',
        'error-message-pattern': 'Error message pattern',
        'stack-trace-pattern': 'Stack trace pattern',
        'view-matched-results': 'View matched results',
        'rule-name-placeholder': 'Give your automation rule a name...',
        'error-message-pattern-placeholder': 'Input the error message, or use regex ^[a-zA-Z0-9_.-*$',
        'stack-trace-pattern-placeholder': 'Input the stack trace, or use regex ^[a-zA-Z0-9_.-*$',
        more: 'More',
        current: 'Current',
        'match-results-dialog#title': 'Matched results',
        'match-results-dialog#constraint': 'Test results of current project within last 30 days matched defined pattern.',
        'match-results-dialog#no-match': 'No match found for this automation rule.',
        'create-rule-main-tooltip': 'Automation Rule allows linking the Defect to similar Test Results automatically.',
        'match-results-tooltip': 'View how many current test result match your input pattern.',
        'create-rule-tooltip': 'Based on the current issue, you have the flexibility to define patterns using either exact text or regular expression syntax. Upcoming Test Results will be auto-linked to this Defect when its error message or stack trace matches your pattern.',
        'delete-automation-rule#title': 'Delete Automation Rule',
        'delete-automation-rule#content#part-one': 'This action will permanently delete the selected automation rule from the defect ',
        'delete-automation-rule#content#part-two': 'It cannot be undone.',
        'delete-automation-rule#content#part-three': 'Are you sure you want to delete the automation rule ',
        'empty-automation-rules': 'No automation rule has been created yet.',
        confirm: 'Confirm',
        by: 'by',
        'created-at': 'Created at',
        'not-defined': 'Not defined.',
        success: 'Success',
        error: 'Error',
        'automation-rule#delete-success-title': 'Success',
        'automation-rule#delete-success-description': 'Automation rule <b>{{ruleName}}</b> has been deleted successfully.',
        'automation-rule#delete-failed-title': 'Error',
        'automation-rule#delete-failed-description': 'Cannot delete automation rule <b>{{ruleName}}</b>. Please try again.',
        need_review: 'Need review',
        'filter-unresolved-test-result#tooltip': 'Display only the test results with statuses Failed/Error/Incomplete that have not been linked with any defects yet.',
        'require-jira-configure-warning': 'You need to set up a Jira project first. Go to the',
        'require-slack-configure-warning': 'You need to setup Slack integration first to receive defect notification. Go to the',
        'slack-notifications-info': 'Configure notification to receive real-time TestOps defects updates in your Slack workspace via the',
        'slack-notifications-header': 'Slack notifications',
        'slack-manually-option': 'Notify channel when a defect has been linked by project member.',
        'slack-automatically-option': 'Notify channel when a defect has been linked by automation rule.',
        'katalon-plugin': 'Katalon Plugin',
        'linked-projects': 'Linked Projects',
        'empty-state-defect#test-result': 'No defect is currently linked to this test result. To link a defect, click the "Report Defect" button.',
        'empty-state-defect#test-run': 'No defects are currently linked to the test results in this test run. Click on a specific test result and use the "Report Defect" button to link a defect.',
        'suggested-defects': 'Suggested Defects',
        'suggested-defects#tooltip': 'Top 3 defects associated with recent similar failures in current test result.',
        'suggested-defects#no-data': 'No suggested defects.',
        'select-existing-issue': 'Select existing issue',
        'go-to-test-result-details': 'Go to Test Result details',
        'view-latest-test-result': 'View Latest Test Result of Test Case',
        'view-by': 'View by',
        'email-config#add-user-header': 'Add User',
        'email-config#add-user': 'Add user',
        'email-config#daily-summary-report': 'Daily Summary Report',
        'email-config#daily-summary-report#desc': 'Get notified daily of all Test Runs throughout the day.',
        'email-config#daily-summary-report#user-desc': 'Get notified daily of all Test Runs from your following projects throughout the day.',
        'email-config#add-user#desc': 'Add recipients will be received Daily Summary Report for this Project.',
        'email-config#add-user-dialog#desc': 'Only users in the organization can be added to the project.',
        'email-config#project-name': 'Project name',
        'email-config#go-to-settings': 'Go To Settings',
        unsubscribe: 'Unsubscribe',
        'error-code-02200-body': 'Jira\'s response: "{{message}}".<br><br>Error occurred when calling the API \'{{uri}}\'. Please double-check your Jira setup.',
        'error-code-02200-title': 'Jira Integration Error',
        'invalid-issue-type': 'Invalid Xray Issue',
        'local-variables': 'Local Variables',
        'low-availability': 'Low Availability',
        'g3-testschedule-disable': 'This test schedule was created in the new version of TestOps. Visit the new version to run, edit, or delete it.'
      },
    },
  },
})
  .catch(() => {});

export function t(key, params) {
  if (params) {
    return i18next.t(key, params);
  }
  return i18next.t(key);
}

export const brand = <span><span className="brand_name">{t('brand_name')}</span></span>;
